{
  "LOGIN": {
    "TITLE": "Bienvenido de nuevo",
    "SUBTITLE": "Ingresa tus credenciales para acceder a tu cuenta",
    "EMAIL_PLACEHOLDER": "tu@ejemplo.com",
    "PASSWORD_LABEL": "Contraseña",
    "SUBMIT": "Iniciar sesión",
    "SUBMITTING": "Iniciando sesión...",
    "QUICK_LOGIN": "Acceso rápido",
    "QUICK_SUPER_ADMIN": "Super Admin",
    "QUICK_ADMIN": "Admin",
    "FORGOT_PASSWORD": "¿Olvidaste tu contraseña?"
  },

  "FORGOT_PASSWORD": {
    "TITLE": "Restablecer contraseña",
    "SUBTITLE": "Ingresa tu email y te enviaremos las instrucciones",
    "CHECK_INBOX": "Revisa tu bandeja de entrada",
    "EMAIL_SENT": "Hemos enviado un enlace de recuperación a tu email",
    "EMAIL_LABEL": "Dirección de Email",
    "EMAIL_PLACEHOLDER": "nombre@empresa.com",
    "SEND_INSTRUCTIONS": "Enviar instrucciones",
    "SENDING": "Enviando...",
    "SENT_TO": "Enviado a",
    "CHECK_SPAM": "¿No recibiste el email? Revisa tu carpeta de spam o intenta de nuevo.",
    "TRY_ANOTHER_EMAIL": "Probar con otro email",
    "BACK_TO_LOGIN": "Volver al inicio de sesión"
  },

  "MOBILE": {
    "HUB_TITLE": "Welty",
    "HUB_SCREEN_TITLE": "Inicio",
    "BACK": "Atrás"
  },

  "PWA_INSTALL": {
    "BANNER_LABEL": "Instalar app",
    "TITLE": "Instala Welty en tu teléfono",
    "ANDROID_HINT": "Añade Welty a la pantalla de inicio para acceder más rápido.",
    "ANDROID_MANUAL": "Abre el menú del navegador (⋮) y pulsa «Instalar aplicación» o «Añadir a la pantalla de inicio». En un servidor de desarrollo por Wi‑Fi puede no aparecer el botón automático: usa «Añadir a la pantalla de inicio».",
    "IOS_INSTRUCTIONS": "Toca Compartir y elige «Añadir a la pantalla de inicio».",
    "INSTALL": "Instalar",
    "LATER": "Ahora no"
  },

  "COMMON": {
    "LOGOUT": "Cerrar sesión",
    "ACTIONS": "Acciones",
    "LOADING": "Cargando...",
    "SAVING": "Guardando...",
    "SELECT_PLACEHOLDER": "Seleccionar...",
    "PER_PAGE": "por página",
    "PREV": "Ant",
    "NEXT": "Sig",
    "NO_DATA": "Sin datos",
    "CANCEL": "Cancelar",
    "ERROR": "Error",
    "EDIT": "Editar",
    "CLOSE": "Cerrar",
    "SAVE": "Guardar",
    "SAVE_SUCCESS": "Guardado correctamente.",
    "CREATE_SUCCESS": "Creado correctamente.",
    "UPDATE_SUCCESS": "Actualizado correctamente.",
    "DELETE_SUCCESS": "Eliminado correctamente.",
    "COPIED": "Copiado al portapapeles.",
    "COPY_FAILED": "No se pudo copiar."
  },

  "CONFIRM_MODAL": {
    "CONFIRM": "Confirmar",
    "CANCEL": "Cancelar",
    "DELETE": "Eliminar"
  },

  "ADMIN": {
    "OVERVIEW": "Resumen",
    "TENANTS": "Inquilinos",
    "ACCOUNT": "Cuenta",
    "SHOWCASE": "Escaparate",
    "TENANT_BLOCK_CONFIRM_TITLE": "Confirmar bloqueo",
    "TENANT_BLOCK_CONFIRM_MESSAGE": "¿Seguro que quieres bloquear este tenant?\n<strong>{{name}}</strong>",
    "TENANT_UNBLOCK_CONFIRM_TITLE": "Confirmar desbloqueo",
    "TENANT_UNBLOCK_CONFIRM_MESSAGE": "¿Seguro que quieres desbloquear este tenant?\n<strong>{{name}}</strong>",
    "TENANT_REMOVE_USER_CONFIRM_TITLE": "Confirmar eliminación",
    "TENANT_REMOVE_USER_CONFIRM_MESSAGE": "¿Seguro que quieres eliminar este usuario del tenant?\n<strong>{{name}}</strong>",
    "TENANT_INVITE_DELETE_CONFIRM_TITLE": "Cancelar invitación",
    "TENANT_INVITE_DELETE_CONFIRM_MESSAGE": "¿Seguro que quieres cancelar esta invitación?\n<strong>{{email}}</strong>",
    "TENANT_INVITE_RENEW_CONFIRM_TITLE": "Renovar invitación",
    "TENANT_INVITE_RENEW_CONFIRM_MESSAGE": "¿Seguro que quieres renovar esta invitación?\n<strong>{{email}}</strong>",
    "TENANT_INVITE_RESEND_CONFIRM_TITLE": "Reenviar invitación",
    "TENANT_INVITE_RESEND_CONFIRM_MESSAGE": "¿Seguro que quieres reenviar esta invitación?\n<strong>{{email}}</strong>",
    "USER_ROLE_UPDATE_ERROR": "No se pudo actualizar el rol del usuario.",
    "INVITES_LOAD_FAILED": "No se pudieron cargar las invitaciones.",
    "INVITE_CREATE_FAILED": "No se pudo crear la invitación.",
    "INVITE_RENEW_FAILED": "No se pudo renovar la invitación.",
    "INVITE_RESEND_FAILED": "No se pudo reenviar la invitación.",
    "INVITE_DELETE_FAILED": "No se pudo cancelar la invitación.",
    "INVITE_RENEWED_SUCCESS": "Invitación renovada. Se ha enviado un nuevo correo.",
    "INVITE_RESENT_SUCCESS": "Invitación reenviada correctamente.",
    "SUPER_ADMIN_INVITE_FAILED": "No se pudo enviar la invitación.",
    "WHATSAPP": {
      "TITLE": "WhatsApp / Twilio",
      "SYNC_TWILIO": "Sincronizar números desde Twilio",
      "PENDING_REQUESTS": "Solicitudes de conexión pendientes",
      "NO_PENDING": "No hay solicitudes pendientes.",
      "COL_TENANT": "Inquilino",
      "COL_NUMBER": "Asignar número",
      "COL_ASSIGNED": "Inquilino asignado",
      "COL_E164": "E.164",
      "COL_SID": "SID",
      "USAGE_CATEGORY": "Categoría",
      "USAGE_COUNT": "Cantidad",
      "USAGE_PRICE": "Precio",
      "SELECT_NUMBER": "Selecciona un número…",
      "APPROVE": "Aprobar",
      "REJECT": "Rechazar",
      "NO_INVENTORY": "No hay números en el inventario. Sincroniza desde Twilio para cargarlos.",
      "INVENTORY": "Inventario de números",
      "USAGE": "Uso (Twilio)",
      "COL_ACTIONS": "Acciones",
      "DISCONNECT": "Desconectar",
      "DISCONNECT_CONFIRM": "¿Desconectar WhatsApp del inquilino que usa {{e164}}? El número quedará disponible para reasignar.",
      "DISCONNECT_SUCCESS": "WhatsApp desconectado. El número vuelve a estar disponible.",
      "DISCONNECT_ERROR": "No se pudo desconectar WhatsApp para este inquilino."
    }
  },

  "NAV": {
    "DASHBOARD": "Panel",
    "CONVERSATIONS": "Conversaciones",
    "NOTIFICATIONS": "Notificaciones",
    "CONTACTS": "Contactos",
    "KNOWLEDGE_BASE": "Base de conocimiento",
    "FLOWS": "Flujos",
    "SERVICES": "Servicios",
    "APPOINTMENTS": "Citas",
    "COLLABORATORS": "Colaboradores",
    "INSIGHTS": "Informes",
    "FLOOR_PLAN": "Plano",
    "FLOOR_PLAN_LIVE": "Sala (en vivo)",
    "FLOOR_PLAN_ANALYTICS": "Analytics de sala",
    "FOOD_SETTINGS": "Restaurante",
    "SETTINGS": "Ajustes",
    "SECTION_FOOD": "Servicios de comida",
    "SECTION_PERSONAL_CARE": "Atención personal"
  },

  "FOOD_SETTINGS": {
    "TITLE": "Restaurante y reservas",
    "SUBTITLE": "Los horarios aplican a reservas por chat y en sala en vivo. Cada día usa UTC (igual que las fechas operativas).",
    "HERO_EYEBROW": "Food · Reservas",
    "LOADING": "Cargando…",
    "SAVE": "Guardar",
    "SAVE_SUCCESS": "Ajustes de restaurante guardados.",
    "ERROR_LOAD": "No se pudieron cargar los ajustes del restaurante.",
    "ERROR_SAVE": "No se pudieron guardar los ajustes del restaurante.",
    "INVALID_DAY_HOURS": "Una o más horas no son válidas. Usa formato 24h (horas 00–23, minutos 00–59).",
    "MISSING_DAY_HOURS": "Indica apertura y cierre en cada día abierto.",
    "MISSING_DAY_INTERVALS": "Cada día abierto necesita al menos una franja con hora de apertura y cierre.",
    "CLOSE_NOT_AFTER_OPEN": "El cierre debe ser después de la apertura el mismo día calendario, salvo horario nocturno (cierre «antes» que la apertura en el reloj, p. ej. 22:00–02:00).",
    "SAME_OPEN_CLOSE": "La apertura y el cierre no pueden ser iguales.",
    "OVERNIGHT_LIMIT": "Solo se permite una franja nocturna por día (p. ej. 22:00–02:00).",
    "OVERLAPPING_INTERVALS": "Las franjas del mismo día no pueden solaparse.",
    "ADD_INTERVAL": "Añadir franja horaria",
    "REMOVE_INTERVAL_ARIA": "Quitar esta franja horaria",
    "INVALID_WEEKLY_SHAPE": "Los datos de horario semanal están incompletos. Recarga la página e inténtalo de nuevo.",
    "AT_LEAST_ONE_OPEN_DAY": "Deja al menos un día abierto.",
    "SECTION_WEEKLY_HOURS": "Horario por día",
    "HINT_WEEKLY_UTC": "Cada día puedes definir una o más franjas de apertura/cierre (p. ej. comida y cena) o marcar cerrado. La semana es domingo–sábado en UTC. Cierre 00:00 = medianoche al final de ese día (no el inicio del siguiente). Para servicio nocturno real (p. ej. 22:00–02:00) usa una hora de cierre posterior a 00:01.",
    "CLOSED": "Cerrado",
    "OPENS": "Abre",
    "CLOSES": "Cierra",
    "SECTION_SLOTS": "Reservas y rotación de mesa",
    "DURATION_MIN": "Duración estándar de la estancia (minutos)",
    "MIN_DURATION": "Estancia mínima (minutos)",
    "MAX_DURATION": "Estancia máxima (minutos)",
    "PREP_MIN": "Tiempo de preparación antes de sentar (minutos)",
    "COOLDOWN_MIN": "Tiempo de limpieza tras marcharse (minutos)",
    "GRID_STEP": "Paso de la rejilla de horarios (minutos)",
    "BUFFER_TOTAL": "Ventana típica bloqueada por grupo: {{minutes}} minutos (preparación + duración estándar + enfriamiento).",
    "MIN_MAX_DURATION": "La estancia mínima no puede ser mayor que la máxima.",
    "SECTION_NO_AVAIL": "Chat: mensaje sin disponibilidad",
    "HINT_NO_AVAIL": "Se muestra cuando el chatbot no encuentra mesa (tras ±30 minutos). Variables: {date}, {time}, {partySize}, {restaurant}, {phone} (teléfono del negocio en el perfil tenant). El chatbot debe enviar el texto literalmente.",
    "NO_AVAIL_TEMPLATE": "Plantilla del mensaje",
    "NO_AVAIL_PLACEHOLDER": "Lo sentimos, no hay mesas el {date} hacia las {time} para {partySize} comensales.",
    "SECTION_PARTY_SIZE_EXCEEDED": "Chat: grupo demasiado grande",
    "HINT_PARTY_SIZE_EXCEEDED": "Se muestra cuando el número de comensales supera la capacidad máxima de mesas y combinaciones en la planta. Variables: {partySize}, {maxPartySize}, {date}, {restaurant}, {phone}. El chatbot debe enviar el texto literalmente.",
    "PARTY_SIZE_EXCEEDED_TEMPLATE": "Plantilla del mensaje",
    "PARTY_SIZE_EXCEEDED_PLACEHOLDER": "Lo sentimos, no podemos sentar a {partySize} comensales: nuestra configuración máxima es de {maxPartySize} plazas. Llámanos al {phone} o prueba con un grupo más pequeño.",
    "PREVIEW_LABEL": "Vista previa (valores de ejemplo)",
    "SLOT_STEP": "Paso de franja (minutos)",
    "HINT_SLOTS": "Los inicios usan el paso de rejilla (p. ej. cada 15 minutos). Preparación y enfriamiento amplían el bloqueo de la mesa antes y después de la estancia. Mín/máx permiten duraciones distintas cuando el calendario lo permite (incluidos huecos parciales en el chat).",
    "DAY_OPEN_LABEL": "Abierto",
    "DAY_CLOSED_LABEL": "Cerrado",
    "DAY_TOGGLE_ARIA": "Abrir o cerrar {{label}}",
    "DAY_OFF_HELP": "Los clientes no pueden reservar este día. Activa el interruptor para definir el horario.",
    "CALLOUT_SLOTS": "Ejemplo: estancia estándar 60 min, rejilla 15 min → posibles inicios cada 15 minutos si la mesa está libre para toda la estancia más los márgenes. En el chat, los huecos parciales usan una hora de fin más temprana si solo hay un intervalo corto antes de la siguiente reserva.",
    "WEEKDAYS": {
      "D0": "Domingo",
      "D1": "Lunes",
      "D2": "Martes",
      "D3": "Miércoles",
      "D4": "Jueves",
      "D5": "Viernes",
      "D6": "Sábado"
    }
  },

  "LAYOUT": {
    "DEFAULT_SECTION_LABEL": "Atención personal",
    "CHANGE_TENANT": "Cambiar tenant",
    "SELECT_TENANT": "Seleccionar tenant..."
  },

  "NOTIFICATIONS_PAGE": {
    "SUBTITLE": "Elementos accionables y no leídos para tu tenant.",
    "UNREAD": "No leído",
    "READ": "Leído",
    "ACTION_NEEDED": "Se necesita acción",
    "EMPTY_UNREAD": "No hay notificaciones no leídas.",
    "EMPTY_READ": "Aún no hay notificaciones leídas.",
    "EMPTY_ACTION_NEEDED": "No hay acciones necesarias en este momento.",
    "EMPTY_ALL": "Sin notificaciones.",
    "SYSTEM": "Sistema",
    "SYSTEM_COMING_SOON": "Las notificaciones del sistema aparecerán aquí.",
    "FILTER_ALL": "Todas",
    "FILTER_UNREAD": "No leídas",
    "FILTER_READ": "Leídas",
    "FILTER_APPOINTMENTS": "Citas",
    "FILTER_APPOINTMENTS_UNREAD": "Citas - No leídas",
    "FILTER_CHAT": "Chat",
    "FILTER_CHAT_UNREAD": "Chat - No leídas",
    "FILTER_SYSTEM": "Sistema",
    "FILTER_NEW_MEMBER": "Nuevo miembro",
    "TYPE_CHAT_INTERVENTION_NEEDED": "Intervención en chat",
    "TYPE_SYSTEM_ERROR": "Error del sistema",
    "TYPE_APPOINTMENT_NEW": "Nueva cita",
    "TYPE_APPOINTMENT_CANCELLED": "Cita cancelada",
    "TYPE_APPOINTMENT_MODIFIED": "Cita actualizada",
    "TYPE_TENANT_NEW_MEMBER": "Nuevo miembro del equipo",
    "COLUMN_TYPE": "Tipo",
    "COLUMN_TITLE": "Título",
    "COLUMN_STATUS": "Estado",
    "COLUMN_DATE": "Fecha",
    "COLUMN_DETAILS": "Detalles",
    "DETAILS_CREATED_AT": "Creado",
    "DETAILS_APPOINTMENT_ID": "Cita",
    "DETAILS_ERROR_CODE": "Código de error",
    "DETAILS_OPEN_CHAT": "Abrir chat",
    "ACTION_GO_TO_AGENDA": "Ir a la agenda",
    "ACTION_GO_TO_TEAM": "Ir al equipo"
  },

  "SIDEBAR": {
    "HELP_TITLE": "¿Necesitas ayuda?",
    "HELP_TEXT": "Contacta con soporte o consulta las guías.",
    "COLLAPSE": "Contraer barra lateral",
    "EXPAND": "Expandir barra lateral",
    "MAIN_NAV": "Navegación principal"
  },

  "SETTINGS": {
    "TABS": {
      "PROFILE": "Perfil",
      "BUSINESS": "Empresa",
      "NOTIFICATIONS": "Notificaciones",
      "APPEARANCE": "Apariencia",
      "SECURITY": "Seguridad",
      "BILLING": "Facturación",
      "INTEGRATIONS": "Integraciones",
      "CHATBOT": "Chatbot"
    },
    "PROFILE_TITLE": "Configuración del perfil",
    "CHANGE_PHOTO": "Cambiar foto",
    "PHOTO_HINT": "JPG, PNG o GIF. Máx. 2MB.",
    "FIRST_NAME": "Nombre",
    "LAST_NAME": "Apellidos",
    "EMAIL": "Email",
    "PHONE": "Teléfono",
    "PROFILE_SAVED": "Perfil guardado correctamente.",
    "SAVE_CHANGES": "Guardar cambios",
    "SAVING": "Guardando...",
    "FOOD_SETTINGS_LINK": "Abrir ajustes de restaurante y reservas",
    "FOOD_SETTINGS_LINK_HINT": "Horario, días laborables y duración de reserva están en una página dedicada.",
    "BUSINESS_TITLE": "Datos de la empresa",
    "UPLOAD_LOGO": "Subir logo",
    "LOGO_HINT": "Tamaño recomendado 400x400px.",
    "COMPANY_NAME": "Nombre de la empresa",
    "INDUSTRY": "Sector",
    "BUSINESS_ADDRESS": "Dirección",
    "TAX_INFO_TITLE": "Información fiscal",
    "VAT_ID": "CIF/NIF",
    "CURRENCY": "Moneda",
    "BUSINESS_SAVED": "Información de la empresa guardada correctamente.",
    "SAVE_BUSINESS": "Guardar información de la empresa",
    "COMM_PREFS_TITLE": "Preferencias de notificaciones",
    "COMM_PREFS_SUBTITLE": "Los canales de envío aplican a todo el espacio de trabajo. Solo los administradores pueden cambiarlos; los operadores pueden vincular su Telegram abajo.",
    "NOTIF_ROW_APPOINTMENT_NEW": "Nueva cita recibida",
    "NOTIF_ROW_APPOINTMENT_NEW_DESC": "Cuando un cliente reserva vía chatbot o formularios.",
    "NOTIF_ROW_APPOINTMENT_CANCELLED": "Cita cancelada o eliminada",
    "NOTIF_ROW_APPOINTMENT_CANCELLED_DESC": "Cuando una cita se cancela o se elimina.",
    "NOTIF_ROW_APPOINTMENT_MODIFIED": "Cita modificada",
    "NOTIF_ROW_APPOINTMENT_MODIFIED_DESC": "Cuando cambian fecha, hora, servicio u otros detalles.",
    "NOTIF_ROW_TENANT_MEMBER": "Nuevo colaborador o administrador",
    "NOTIF_ROW_TENANT_MEMBER_DESC": "Cuando alguien se une al equipo del tenant.",
    "NOTIF_ROW_HUMAN_ASSISTANT": "Asistencia humana necesaria",
    "NOTIF_ROW_HUMAN_ASSISTANT_DESC": "Cuando una conversación necesita un operador o hay un problema de configuración del chatbot.",
    "NOTIF_MATRIX_EVENT": "Notificación",
    "NOTIF_CHANNEL_IN_APP": "Lista en la app",
    "NOTIF_CHANNEL_EMAIL": "Correo",
    "NOTIF_CHANNEL_TELEGRAM": "Telegram",
    "NOTIF_SAVE": "Guardar preferencias de notificaciones",
    "NOTIF_TELEGRAM_INFO_TITLE": "Notificaciones Telegram",
    "NOTIF_TELEGRAM_INFO_DESC": "Tras conectar el bot de notificaciones (Integraciones), cualquiera que abra el bot y pulse Iniciar recibirá automáticamente las alertas de los eventos con Telegram activo arriba. Para darse de baja, enviar /stop al bot.",
    "NOTIF_TELEGRAM_OPEN_BOT": "Abrir bot en Telegram",
    "NOTIF_TELEGRAM_BOT_NOT_CONNECTED": "Conecta primero el bot de notificaciones (pestaña Integraciones).",
    "NOTIF_TELEGRAM_SUBSCRIBERS": "Suscriptores activos",
    "NOTIFICATION_PREFS": {
      "LOADING": "Cargando preferencias…",
      "NO_TENANT": "Selecciona un tenant para gestionar las notificaciones.",
      "ERROR_LOAD": "No se pudieron cargar las preferencias de notificaciones.",
      "ERROR_SAVE": "No se pudieron guardar las preferencias de notificaciones."
    },
    "NOTIFICATIONS_TELEGRAM_BOT_TITLE": "Bot de notificaciones (tenant)",
    "NOTIFICATIONS_TELEGRAM_BOT_DESC": "Crea un bot de Telegram separado con BotFather solo para notificaciones al personal. Cualquiera que abra el bot y pulse Iniciar recibirá las alertas; este bot no atiende el chat de clientes.",
    "NOTIFICATIONS_TELEGRAM": {
      "CONNECT": "Conectar bot de notificaciones",
      "DISCONNECT": "Desconectar bot",
      "DISCONNECT_CONFIRM_TITLE": "¿Desconectar el bot de notificaciones?",
      "DISCONNECT_CONFIRM_MESSAGE": "El personal dejará de recibir notificaciones por Telegram hasta conectar un nuevo bot.",
      "CONNECT_ERROR": "No se pudo conectar el bot de notificaciones.",
      "DISCONNECT_ERROR": "No se pudo desconectar el bot de notificaciones.",
      "LINK_ERROR": "No se pudo iniciar el enlace con Telegram. Asegúrate de que el bot de notificaciones esté configurado e inténtalo de nuevo.",
      "UNLINK_ERROR": "No se pudo desvincular Telegram."
    },
    "APPEARANCE_TITLE": "Apariencia",
    "THEME_PREFERENCES": "Preferencias de tema",
    "THEME_LIGHT": "Claro",
    "THEME_DARK": "Oscuro",
    "SECURITY_TITLE": "Seguridad e inicio de sesión",
    "TWO_FA_TITLE": "Autenticación de dos factores",
    "TWO_FA_DESC": "Añade una capa extra de seguridad requiriendo más que la contraseña para iniciar sesión.",
    "SETUP_2FA": "Configurar 2FA",
    "CHANGE_PASSWORD": "Cambiar contraseña",
    "CURRENT_PASSWORD": "Contraseña actual",
    "NEW_PASSWORD": "Nueva contraseña",
    "PASSWORD_UPDATED": "Contraseña actualizada correctamente.",
    "UPDATING": "Actualizando...",
    "UPDATE_PASSWORD": "Actualizar contraseña",
    "ACTIVE_SESSIONS": "Sesiones activas",
    "ACTIVE_NOW": "Activo ahora",
    "LAST_ACTIVE_AGO": "Última actividad hace 2h",
    "BILLING_UNAVAILABLE": "La facturación no está disponible aún.",
    "INTEGRATIONS_TITLE": "Integraciones",
    "CHATBOT_TITLE": "Mensajes del chatbot",
    "CHATBOT_IDENTIFICATION_TITLE": "Onboarding",
    "CHATBOT_KNOWLEDGE_BASE_TITLE": "Base de conocimientos",
    "CHATBOT_ERRORS_TITLE": "Mensajes de error",
    "CHATBOT_SAVED": "Mensajes del chatbot guardados correctamente.",
    "APPOINTMENT_CALENDARS": "Calendarios de citas",
    "GOOGLE_CALENDAR": "Google Calendar",
    "GOOGLE_CALENDAR_DESC": "Sincroniza citas automáticamente",
    "MANAGE_CONNECTION": "Gestionar conexión",
    "APPLE_CALENDAR": "Apple Calendar",
    "APPLE_CALENDAR_DESC": "Sincronización bidireccional con iCloud",
    "CONNECT": "Conectar",
    "CONVERSATIONS_SECTION": "Conversaciones",
    "WHATSAPP_BUSINESS": "WhatsApp Business",
    "CONNECTED": "Conectado:",
    "WHATSAPP_CONNECT_DESC": "Solicita un número WhatsApp. Un super admin lo asignará tras la aprobación.",
    "WHATSAPP_PENDING": "Solicitud pendiente de aprobación.",
    "WHATSAPP_REJECTED": "Tu última solicitud fue rechazada. Puedes enviar una nueva.",
    "REQUEST_WHATSAPP": "Solicitar conexión",
    "DISCONNECT": "Desconectar",
    "CONNECT_NUMBER": "Solicitar conexión",
    "TELEGRAM_BOT": "Bot de Telegram",
    "CHATBOT": {
      "WELCOME_MESSAGE": "¡Hola! Soy el bot. Para continuar necesito alguna información. ¿Cuál es tu nombre?",
      "WELCOME_BACK_MESSAGE": "¡Bienvenido de nuevo! ¿Cómo puedo ayudarte?",
      "CONFIRMATION_MESSAGE": "¡Gracias! Has sido registrado. ¿Cómo puedo ayudarte?",
      "FIRST_NAME_QUESTION": "¿Cuál es tu nombre? (nombre)",
      "LAST_NAME_QUESTION": "¿Cuál es tu apellido?",
      "PHONE_QUESTION": "¿Cuál es tu número de teléfono? (ej. 333 1234567)",
      "NO_INFORMATION_AVAILABLE": "Lo siento, no tengo información sobre ese tema en mi base de conocimientos.",
      "ERROR_OCCURRED": "Ocurrió un error. Por favor, inténtalo de nuevo más tarde.",
      "ERROR_LOAD": "No se pudieron cargar los mensajes del chatbot.",
      "ERROR_SAVE": "No se pudieron guardar los mensajes del chatbot.",
      "SYSTEM_MESSAGES": {
        "TITLE": "Mensajes del sistema",
        "SUBTITLE": "Personaliza los mensajes automáticos que la IA envía en distintas situaciones. Si dejas un campo vacío, se usará el texto predeterminado.",
        "PLACEHOLDER": "Ingresa un texto personalizado (opcional)",
        "LABELS": {
          "WELCOME": "Mensaje de bienvenida",
          "KB_NOT_FOUND": "Información no encontrada en la Knowledge Base",
          "SYSTEM_ERROR": "Error del sistema",
          "OUT_OF_HOURS": "Fuera de horario",
          "HANDOFF_TO_HUMAN": "Transferencia a un operador humano",
          "NO_OPERATOR_AVAILABLE": "No hay operadores disponibles",
          "BOOKING_CONFIRMED": "Reserva confirmada",
          "BOOKING_RESCHEDULED": "Reserva modificada",
          "BOOKING_CANCELLED": "Reserva cancelada",
          "NO_AVAILABILITY_FOUND": "No se encontró disponibilidad",
          "FORM_SENT": "Formulario enviado al usuario",
          "FORM_COMPLETED_THANKS": "Formulario completado — agradecimiento",
          "INPUT_NOT_UNDERSTOOD": "Entrada no comprendida",
          "UNSUPPORTED_MEDIA": "Mensaje no compatible (media/archivo)",
          "PRIVACY_CONSENT_REQUEST": "Solicitud de consentimiento de privacidad (GDPR)",
          "PRIVACY_CONSENT_DENIED": "Consentimiento de privacidad denegado",
          "CONVERSATION_CLOSED": "Conversación cerrada",
          "REACTIVATION": "Mensaje de reactivación"
        }
      },
      "FOOD_DINING": {
        "TITLE": "Reservas de mesa por chat",
        "SUBTITLE": "Solo negocios de comida: indica el Servicio usado cuando la IA crea reservas de mesa (crea p. ej. “Reserva de mesa” en Servicios). Los horarios usan el mismo día UTC que el plano de sala.",
        "SERVICE_ID": "ID del servicio de reserva de mesa",
        "SERVICE_HINT": "ID MongoDB de 24 caracteres desde la lista de servicios.",
        "SERVICE_PLACEHOLDER": "p. ej. 674a1b2c3d4e5f6789012345",
        "DURATION": "Duración de la reserva (minutos)",
        "DAY_START": "Primera hora reservable (HH:mm)",
        "DAY_END": "Límite del día para el último hueco (HH:mm)",
        "SLOT_STEP": "Minutos entre horas de inicio ofrecidas",
        "SAVE": "Guardar ajustes de reserva de mesa",
        "ERROR_SAVE": "No se pudieron guardar los ajustes de reserva de mesa."
      }
    },
    "TELEGRAM": {
      "SETUP_TITLE": "Configurar Bot de Telegram",
      "SETUP_SUBTITLE": "Sigue los pasos para crear y configurar tu bot de Telegram",
      "CLOSE_ARIA": "Cerrar",
      "QR_GENERATING": "Generando código QR...",
      "QR_FALLBACK": "Si el código QR no aparece, usa el enlace de abajo para abrir BotFather",
      "QR_HINT": "Escanea el código QR con Telegram para abrir BotFather directamente",
      "OPEN_BOTFATHER": "O abre BotFather manualmente",
      "STEPS_TITLE": "Pasos a seguir:",
      "STEP_1_TITLE": "Abre Telegram",
      "STEP_1_DESC": "Abre la app de Telegram en tu móvil o escritorio",
      "STEP_2_TITLE": "Busca BotFather",
      "STEP_2_DESC": "Busca @BotFather en la barra de búsqueda de Telegram",
      "STEP_3_TITLE": "Crea un nuevo bot",
      "STEP_3_DESC": "Envía el comando /newbot a BotFather",
      "STEP_4_TITLE": "Configura el bot",
      "STEP_4_DESC": "Elige un nombre y un usuario para tu bot (debe terminar en \"bot\")",
      "STEP_5_TITLE": "Copia el token",
      "STEP_5_DESC": "BotFather te dará un Bot Token. Cópialo y pégalo abajo",
      "BOT_TOKEN_LABEL": "Bot Token",
      "BOT_TOKEN_PLACEHOLDER": "123456789:ABCdefGHIjklMNOpqrsTUVwxyz",
      "BOT_TOKEN_HINT": "Pega aquí el token proporcionado por BotFather después de crear el bot",
      "TOKEN_REQUIRED": "El token del bot es obligatorio",
      "TOKEN_INVALID": "Formato de token no válido. Debe ser: número:caracteres",
      "CANCEL": "Cancelar",
      "CONNECT_BOT": "Conectar Bot",
      "CONNECTING": "Conectando...",
      "QR_MODAL_TITLE": "Código QR del bot",
      "QR_MODAL_HINT": "Escanea el código QR con la cámara para abrir el bot en Telegram",
      "DOWNLOAD_QR": "Descargar imagen QR",
      "COPY_LINK": "Copiar enlace",
      "LINK_COPIED": "Enlace copiado",
      "SHARE_BOT_LINK": "Comparte el enlace de tu bot",
      "OPEN_BOT_ON_TELEGRAM": "Abrir bot en Telegram",
      "QR_OR_SHARE": "Código QR / Compartir",
      "BOT_CONNECTED_ACTIVE": "Bot conectado y activo",
      "INTEGRATE_BOT": "Integra tu bot para notificaciones y chat.",
      "CONFIGURE_BOT": "Configurar Bot",
      "DISCONNECT_CONFIRM_TITLE": "Desconectar Telegram",
      "DISCONNECT_CONFIRM_MESSAGE": "¿Seguro que quieres desconectar Telegram? No recibirás más mensajes.",
      "CONNECT_ERROR": "Error: verifica que el token del bot sea válido. Obténlo de @BotFather en Telegram.",
      "DISCONNECT_ERROR": "Error al desconectar Telegram."
    },
    "WHATSAPP_SHARE": {
      "CLOSE_ARIA": "Cerrar",
      "QR_GENERATING": "Generando código QR…",
      "QR_MODAL_TITLE": "Número de WhatsApp",
      "QR_MODAL_HINT": "Escanea el código QR con el móvil para abrir el chat en WhatsApp",
      "QR_IMAGE_ALT": "Código QR para abrir WhatsApp",
      "DOWNLOAD_QR": "Descargar imagen QR",
      "COPY_LINK": "Copiar enlace",
      "LINK_COPIED": "Enlace copiado",
      "SHARE_NUMBER": "Comparte tu número de WhatsApp Business",
      "OPEN_ON_WHATSAPP": "Abrir en WhatsApp",
      "QR_OR_SHARE": "Código QR / Compartir"
    },
    "WIDGET": {
      "TITLE": "Widget de Chat del Sitio Web",
      "DESCRIPTION_GENERATED": "Código de widget generado. Copia el snippet para integrar el widget en tu sitio.",
      "DESCRIPTION_NOT_GENERATED": "Genera un código de widget para integrar el chatbot en tu sitio web.",
      "GENERATE_BUTTON": "Generar Código de Widget",
      "REGENERATE_BUTTON": "Regenerar",
      "ENABLE_BUTTON": "Activar",
      "DISABLE_BUTTON": "Desactivar",
      "COPY_SNIPPET": "Copiar Snippet",
      "TEST_WIDGET": "Probar Widget",
      "LOADING": "Cargando...",
      "ACTIVE": "Activo",
      "INACTIVE": "Inactivo",
      "ERROR_NOT_GENERATED": "Código de widget no generado. Genera un código de widget desde Configuración.",
      "ERROR_LOADING": "Error al cargar el estado del widget",
      "ERROR_GENERATING": "Error al generar el código de widget",
      "ERROR_TOGGLE": "Error al actualizar el estado del widget",
      "REGENERATE_CONFIRM_TITLE": "Regenerar Código de Widget",
      "REGENERATE_CONFIRM_MESSAGE": "¿Estás seguro de que quieres regenerar el código de widget? El código antiguo dejará de funcionar y tendrás que actualizar el snippet en tu sitio.",
      "SNIPPET_COPIED": "¡Snippet copiado al portapapeles!"
    },
    "PROFILE": {
      "ERROR_SAVE": "No se pudo guardar el perfil."
    },
    "BUSINESS": {
      "ERROR_SAVE": "No se pudieron guardar los datos de la empresa."
    },
    "SECURITY": {
      "PASSWORD_ERROR": "No se pudo actualizar la contraseña."
    },
    "AI_AUTO_DISABLE": {
      "ERROR_LOAD": "No se pudieron cargar los ajustes de desactivación automática de la IA.",
      "ERROR_SAVE": "No se pudieron guardar los ajustes de desactivación automática de la IA."
    },
    "INTEGRATIONS": {
      "POPUP_BLOCKED": "Ventana emergente bloqueada. Permite ventanas emergentes para este sitio para continuar."
    },
    "WHATSAPP": {
      "DISCONNECT_ERROR": "No se pudo desconectar WhatsApp.",
      "REQUEST_ERROR": "No se pudo enviar la solicitud de WhatsApp."
    }
  },

  "DASHBOARD": {
    "GOOD_MORNING": "Buenos días",
    "GOOD_AFTERNOON": "Buenas tardes",
    "GOOD_EVENING": "Buenas noches",
    "WELCOME_SUBTITLE": "Esto es lo que pasa con tu negocio hoy.",
    "QUICK_ACTIONS": "Acciones rápidas",
    "KEY_METRICS": "Métricas clave",
    "ACTIVITY": "Actividad",
    "NEW_BOOKING": "Nueva reserva",
    "REPORTS": "Informes",
    "TODAYS_AGENDA": "Agenda de hoy",
    "SOON": "Próximamente",
    "LIVE_INBOX_TITLE": "Conversaciones en vivo",
    "VIEW_ALL": "Ver todo ↗",
    "LIVE_INBOX_DESC": "Últimos mensajes de clientes pendientes de respuesta",
    "OPEN_CHAT": "Abrir chat",
    "AI_SUMMARY": "Resumen IA:",
    "INSIGHTS_TITLE": "Insights diarios",
    "MOST_ASKED_TODAY": "Más preguntado hoy:",
    "SUGGESTION": "Sugerencia:",
    "DEFAULT_QUESTION": "¿Cuánto dura la recuperación?",
    "DEFAULT_SUGGESTION": "3 clientes preguntaron por el cuidado posterior. Considera añadir una \"Respuesta rápida\" para tratamientos de peeling.",
    "DEFAULT_TREND": "Conversión de reservas +5% frente a la semana pasada"
  },

  "TENANT_MODAL": {
    "TITLE_CREATE": "Crear Nuevo Tenant",
    "TITLE_EDIT": "Editar Tenant",
    "SUBTITLE": "Configura ajustes del tenant y preferencias de IA.",
    "SECTION_BUSINESS_DETAILS": "Detalles del Negocio",
    "SECTION_AI_SETTINGS": "Configuración de IA",
    "SECTION_AI_CONFIGURATION": "Configuración de IA",
    "LABEL_AI_NAME": "NOMBRE DE IA",
    "PLACEHOLDER_AI_NAME": "ej. Bot de Soporte",
    "LABEL_AI_PERSONALITY": "PERSONALIDAD Y TONO DE IA",
    "PLACEHOLDER_AI_PERSONALITY": "Eres un asistente de atención al cliente útil y cortés. Hablas con un tono formal...",
    "LABEL_AI_LIMITS": "LÍMITES Y REGLAS DE IA",
    "PLACEHOLDER_AI_LIMITS": "No respondas preguntas sobre política. No proporciones consejos médicos. Longitud máxima de respuesta: 50 palabras...",
    "DESCRIPTION_AI_LIMITS": "Define límites estrictos y reglas operativas para el modelo de IA.",
    "LABEL_BUSINESS_NAME": "NOMBRE DEL NEGOCIO",
    "LABEL_EMAIL": "CORREO ELECTRÓNICO",
    "PLACEHOLDER_EMAIL": "nombre@empresa.com",
    "LABEL_PHONE": "TELÉFONO",
    "LABEL_VERTICAL": "VERTICAL",
    "LABEL_TIER": "PLAN",
    "LABEL_LANGUAGE": "IDIOMA",
    "LABEL_AI_CONFIGURATIONS": "CONFIGURACIONES DE IA",
    "LABEL_AI_TYPE": "TIPO DE IA",
    "LABEL_MODEL": "MODELO",
    "LABEL_API_KEY": "CLAVE API",
    "LABEL_API_KEY_UPDATE": "CLAVE API (dejar vacío para mantener la actual)",
    "PLACEHOLDER_API_KEY": "Introduce clave API",
    "BUTTON_ADD_AI_CONFIG": "Añadir Configuración de IA",
    "BUTTON_CANCEL": "Cancelar",
    "BUTTON_CREATE": "Crear Tenant",
    "BUTTON_UPDATE": "Actualizar Tenant",
    "BUTTON_CREATING": "Creando...",
    "BUTTON_UPDATING": "Actualizando...",
    "ERROR_CREATING": "Error al crear el tenant",
    "ERROR_UPDATING": "Error al actualizar el tenant"
  },

  "CONTACTS": {
    "TITLE": "Contactos",
    "MANAGE_FIELDS": "Gestionar campos",
    "UPLOAD_CONTACT_LIST": "Subir lista de contactos",
    "ADD_CONTACT": "Agregar un contacto",
    "SEARCH_PLACEHOLDER": "Buscar contactos por nombre, email o teléfono...",
    "FILTER_BY": "Filtrar por:",
    "ALL_CONTACTS": "Todos los contactos",
    "ACTIVE": "Activos",
    "INACTIVE": "Inactivos",
    "NO_CONTACTS_FOUND": "No se encontraron contactos",
    "SHOWING": "Mostrando",
    "OF": "de",
    "CONTACTS": "contactos",
    "DELETE_CONFIRM_TITLE": "Confirmar eliminación",
    "DELETE_CONFIRM": "¿Estás seguro de que quieres eliminar este contacto?\n<strong>{{name}}</strong>",
    "ERROR_LOADING": "Error al cargar contactos",
    "ERROR_DELETING": "Error al eliminar contacto",
    "DELETE_SUCCESS": "Contacto eliminado correctamente.",
    "PLATFORMS": {
      "WHATSAPP": "WhatsApp",
      "TELEGRAM": "Telegram",
      "EMAIL": "Email",
      "MANUAL": "Manual",
      "WEBCHAT": "Chat web"
    },
    "STATUS": {
      "ACTIVE": "Activo",
      "INACTIVE": "Inactivo"
    },
    "LAST_ACTIVE": {
      "LABEL": "Última Actividad",
      "JUST_NOW": "Ahora mismo",
      "MINUTES_AGO": "Hace {{minutes}}m",
      "HOURS_AGO": "Hace {{hours}}h",
      "DAYS_AGO": "Hace {{days}}d",
      "WEEKS_AGO": "Hace {{weeks}}s"
    },
    "MODAL": {
      "ADD_TITLE": "Agregar Nuevo Contacto",
      "EDIT_TITLE": "Editar Contacto",
      "ADD_SUBTITLE": "Crea un nuevo perfil en tu espacio de trabajo.",
      "EDIT_SUBTITLE": "Actualiza la información del contacto existente.",
      "BASIC_INFO": "Información Básica",
      "FULL_NAME": "Nombre",
      "FULL_NAME_PLACEHOLDER": "ej. Elena",
      "LAST_NAME": "Apellido",
      "LAST_NAME_PLACEHOLDER": "ej. Rossi",
      "EMAIL_ADDRESS": "Dirección de Email",
      "EMAIL_PLACEHOLDER": "nombre@ejemplo.com",
      "PHONE_NUMBER": "Número de Teléfono",
      "PHONE_PLACEHOLDER": "+39 000 00000",
      "PREFERENCES": "Preferencias",
      "FAVOURITE_CONTACT_METHOD": "Método de contacto favorito",
      "STATUS": "Estado",
      "ACTIVE_STATUS_LABEL": "Estado activo",
      "ACTIVE_STATUS_DESCRIPTION": "¿Este contacto está disponible?",
      "CUSTOM_ATTRIBUTES": "Atributos Personalizados",
      "TAGS_LABELS": "Etiquetas y Marcadores",
      "TAGS_ASSIGNED": "asignados",
      "TAGS_PLACEHOLDER": "Seleccionar etiquetas...",
      "MORE_TAGS": "más +",
      "CANCEL": "Cancelar",
      "CREATE_CONTACT": "Crear Contacto",
      "UPDATE_CONTACT": "Actualizar Contacto",
      "ERROR_CREATING": "Error al crear contacto",
      "ERROR_UPDATING": "Error al actualizar contacto",
      "YES": "Sí",
      "NO": "No",
      "ENTER_FIELD_PLACEHOLDER": "Introduce {{label}}..."
    },
    "DETAIL": {
      "BACK": "Volver",
      "PAGE_TITLE": "Detalle del contacto",
      "SUBTITLE": "Ver y editar la información del contacto",
      "NOT_FOUND": "Contacto no encontrado.",
      "DELETE": "Eliminar",
      "SAVE_SUCCESS": "Contacto actualizado correctamente.",
      "CONVERSATIONS": "Conversaciones",
      "NO_CONVERSATIONS": "Ninguna conversación.",
      "NO_MESSAGES": "Sin mensajes",
      "APPOINTMENTS": "Citas",
      "NO_APPOINTMENTS": "Ninguna cita.",
      "FORMS": {
        "BUTTON": "Formulario",
        "EMPTY": "No hay formularios para esta cita.",
        "TYPE_REQUIRED": "Obligatorio",
        "TYPE_OPTIONAL": "Opcional",
        "TYPE_UNKNOWN": "Tipo no disponible",
        "STATUS_SUBMITTED": "Completado",
        "STATUS_PENDING": "No completado",
        "STATUS_EMPTY": "No disponible",
        "PENDING_INFO": "El cliente aún no ha completado este formulario."
      },
      "SUMMARY": {
        "TITLE": "Resumen IA del contacto",
        "EMPTY": "No hay resumen disponible.",
        "GENERATE": "Generar resumen",
        "REFRESH": "Actualizar resumen",
        "IN_PROGRESS": "Actualización en curso",
        "REFRESH_STARTED": "Generación del resumen iniciada en segundo plano.",
        "REFRESH_ERROR": "No se pudo iniciar la generación del resumen.",
        "STATUS_NOT_STARTED": "No iniciado",
        "STATUS_IN_PROGRESS": "En curso",
        "STATUS_COMPLETE": "Completo",
        "STATUS_FAILED": "Fallido",
        "STATUS_NEED_UPDATE": "Requiere actualización",
        "META_FIRST_COMPLETE": "Primer resumen completado",
        "META_LAST_COMPLETED": "Último resumen completado",
        "META_LAST_REQUESTED": "Última actualización solicitada",
        "META_SOURCE_UPDATED": "Último cambio en datos del contacto",
        "META_VERSION": "Versión del resumen",
        "META_NOT_AVAILABLE": "—",
        "NEED_UPDATE_HINT": "Los datos del contacto cambiaron después del último resumen. Actualiza el resumen para que el asistente IA use información al día."
      },
      "SUMMARY_CHAT": {
        "RESPONDING": "Pensando…"
      }
    },
    "FIELDS_MANAGEMENT": {
      "TITLE": "Gestionar Campos",
      "SUBTITLE": "Configurar etiquetas y atributos personalizados de contactos",
      "TAGS_TAB": "Etiquetas y Marcadores",
      "ONBOARDING_TAB": "Onboarding del chatbot",
      "CUSTOM_FIELDS_TAB": "Campos Personalizados",
      "TAG_INPUT_PLACEHOLDER": "Ingresa el nombre del nuevo etiqueta...",
      "TAG_ALREADY_EXISTS": "La etiqueta ya existe",
      "TAG_CREATED": "Etiqueta creada correctamente.",
      "LOADING_TAGS": "Cargando etiquetas...",
      "ERROR_LOADING_TAGS": "Error al cargar etiquetas",
      "ERROR_CREATING_TAG": "Error al crear etiqueta",
      "ERROR_DELETING_TAG": "Error al eliminar etiqueta",
      "DELETE_TAG_CONFIRM_TITLE": "Confirmar eliminación",
      "DELETE_TAG_CONFIRM_MESSAGE": "¿Estás seguro de que quieres eliminar esta etiqueta?\n<strong>{{name}}</strong>",
      "CREATE_FIELD": "Crear Nuevo Campo Personalizado",
      "EDIT_FIELD": "Editar Campo",
      "FIELD_NAME": "Nombre del Campo",
      "FIELD_NAME_PLACEHOLDER": "ej. Cumpleaños",
      "SLUG_ID": "Slug (ID)",
      "SLUG_PLACEHOLDER": "ej. cumpleanos",
      "FORMAT_TYPE": "Tipo de Formato",
      "TEXT": "Texto",
      "NUM": "Número",
      "DATE": "Fecha",
      "BOOL": "Booleano",
      "ADD_CUSTOM_FIELD": "Agregar Campo Personalizado",
      "UPDATE_FIELD": "Actualizar Campo",
      "LOADING_FIELDS": "Cargando campos personalizados...",
      "ERROR_LOADING_FIELDS": "Error al cargar campos personalizados",
      "ERROR_CREATING_FIELD": "Error al crear campo personalizado",
      "ERROR_UPDATING_FIELD": "Error al actualizar campo personalizado",
      "ERROR_DELETING_FIELD": "Error al eliminar campo personalizado",
      "DELETE_FIELD_CONFIRM_TITLE": "Confirmar eliminación",
      "DELETE_FIELD_CONFIRM_MESSAGE": "¿Estás seguro de que quieres eliminar este campo personalizado?\n<strong>{{name}}</strong>",
      "QUESTION_EXAMPLE": "Pregunta / Ejemplo",
      "QUESTION_EXAMPLE_PLACEHOLDER": "ej. ¿Cuál es tu fecha de nacimiento?",
      "ACTIVE": "Activo",
      "REQUIRED": "Obligatorio",
      "REQUIRED_FOR_ONBOARDING": "Requerido para el onboarding del chatbot",
      "ONBOARDING_HINT": "Si activas “Requerido para el onboarding del chatbot”, el chatbot pedirá este campo antes de continuar. La pregunta utilizada es la de “Pregunta / Ejemplo”.",
      "ONBOARDING_QUESTION": "Pregunta de onboarding",
      "ONBOARDING_QUESTION_EMPTY": "Sin pregunta personalizada",
      "ONBOARDING_TAB_SUBTITLE": "Aquí gestionas los datos base requeridos al inicio del chat: nombre, apellido, teléfono y email (email opcional).",
      "EDIT_ONBOARDING_FIELD": "Editar campo de onboarding",
      "FIELD_ENABLED": "Campo habilitado en la recopilación de datos",
      "SAVE_ONBOARDING_FIELD": "Guardar campo de onboarding",
      "CLOSE_MANAGEMENT": "Cerrar Gestión"
    },
    "FILTERS": {
      "ADVANCED_FILTERS": "Filtros Avanzados",
      "COMMUNICATION_PLATFORM": "Plataforma de Comunicación",
      "CLIENT_LABELS": "Etiquetas del Cliente",
      "LAST_ACTIVE_PERIOD": "Período de Última Actividad",
      "ALL_TIME": "Todo el Tiempo",
      "LAST_7_DAYS": "Últimos 7 días",
      "LAST_30_DAYS": "Últimos 30 días",
      "RESET_ALL": "Restablecer todo",
      "APPLY": "Aplicar"
    }
  },

  "SERVICES": {
    "MANAGE_CATEGORIES": "Gestionar categorías",
    "ADD_SERVICE": "Añadir servicio",
    "SEARCH_PLACEHOLDER": "Buscar servicios por nombre o descripción...",
    "FILTER_BY": "Filtrar por:",
    "ALL": "Todos",
    "ACTIVE": "Activos",
    "INACTIVE": "Inactivos",
    "FILTER_BY_CATEGORY": "Filtrar por categoría",
    "CLEAR": "Limpiar",
    "RESET_FILTERS": "Restablecer filtros",
    "NO_SERVICES": "No se encontraron servicios",
    "PRICE": "Precio",
    "DURATION": "Duración",
    "PREP": "Prep",
    "COOLDOWN": "Cooldown",
    "SHOWING": "Mostrando",
    "OF": "de",
    "SERVICES": "servicios",
    "DELETE_CONFIRM_TITLE": "Confirmar eliminación",
    "DELETE_CONFIRM": "¿Estás seguro de que deseas eliminar este servicio?\n<strong>{{name}}</strong>",
    "ERROR_LOADING": "Error al cargar los servicios",
    "ERROR_DELETING": "Error al eliminar el servicio",
    "FORMS": {
      "ADD_FORM": "Añadir formulario",
      "MANAGE_FORMS": "Gestionar formularios",
      "MANAGE_TITLE": "Gestión de formularios",
      "MANAGE_SUBTITLE": "Ver, editar o eliminar formularios de reserva.",
      "NO_FORMS": "Aún no has creado ningún formulario.",
      "TEST_FORM": "Probar formulario",
      "ADD_TITLE": "Crear formulario",
      "EDIT_TITLE": "Editar formulario",
      "ADD_SUBTITLE": "Configura la estructura y las preguntas del nuevo formulario.",
      "EDIT_SUBTITLE": "Actualiza título, descripción y preguntas del formulario.",
      "METADATA_TITLE": "Ajustes del formulario",
      "NAME": "Nombre del formulario",
      "NAME_PLACEHOLDER": "ej. Cuestionario previo a la visita",
      "DESCRIPTION": "Descripción (opcional)",
      "DESCRIPTION_PLACEHOLDER": "Explica brevemente para qué sirve este formulario...",
      "QUESTIONS_TITLE": "Preguntas del formulario",
      "ADD_QUESTION": "Añadir pregunta",
      "QUESTION_TEXT": "Texto de la pregunta",
      "QUESTION_TEXT_PLACEHOLDER": "ej. ¿Tienes alergias conocidas?",
      "QUESTION_DESCRIPTION": "Descripción de la pregunta (opcional)",
      "QUESTION_DESCRIPTION_PLACEHOLDER": "Añade detalles o instrucciones para esta pregunta...",
      "QUESTION_TYPE": "Tipo de respuesta",
      "QUESTION_REQUIRED": "Respuesta obligatoria",
      "OPTIONS_TITLE": "Opciones de respuesta",
      "ADD_OPTION": "Añadir opción",
      "OPTION_LABEL": "Opción",
      "OPTION_PLACEHOLDER": "ej. Sí",
      "TYPE_TEXT": "Respuesta corta",
      "TYPE_MULTILINE": "Párrafo",
      "TYPE_SINGLE_CHOICE": "Opción única",
      "TYPE_MULTIPLE_CHOICE": "Opción múltiple",
      "TYPE_NUMBER": "Número",
      "TYPE_DATE": "Fecha",
      "BOOKING_FORM_TITLE": "Formulario de reserva",
      "SELECT_FORM": "Selecciona un formulario para adjuntar",
      "NO_FORM": "Sin formulario",
      "REQUIRED_FOR_BOOKING": "Formulario obligatorio para confirmar la reserva",
      "PRIVACY_POLICY_ENABLE": "Activar formulario de Privacy & Policy",
      "PRIVACY_POLICY_TEXT_LABEL": "Texto de Privacy & Policy",
      "PRIVACY_POLICY_TEXT_PLACEHOLDER": "Introduce el texto completo de la política de privacidad",
      "PRIVACY_POLICY_LINK_LABEL": "Enlace de Privacy & Policy",
      "PRIVACY_POLICY_LINK_PLACEHOLDER": "https://...",
      "SAVE": "Guardar formulario",
      "UPDATE": "Actualizar formulario",
      "ERROR_LOADING_FORMS": "Error al cargar los formularios",
      "DELETE_CONFIRM_TITLE": "Eliminar formulario",
      "DELETE_CONFIRM": "¿Seguro que quieres eliminar este formulario?\n<strong>{{name}}</strong>",
      "ERROR_DELETING_FORM": "Error al eliminar el formulario",
      "ERROR_CREATING_TEST_LINK": "Error al crear el enlace de prueba",
      "TEST_LINK_OPENED": "Enlace de prueba abierto en una nueva pestaña.",
      "ERROR_SAVING_FORM": "Error al guardar el formulario",
      "ERROR_UPDATING_FORM": "Error al actualizar el formulario"
    },
    "MODAL": {
      "ADD_TITLE": "Añadir nuevo servicio",
      "EDIT_TITLE": "Editar servicio",
      "ADD_SUBTITLE": "Crea un nuevo servicio para tu catálogo.",
      "EDIT_SUBTITLE": "Actualiza la información del servicio.",
      "DETAILS": "Detalles del servicio",
      "NAME": "Nombre del servicio",
      "NAME_PLACEHOLDER": "ej. Peeling químico",
      "DESCRIPTION": "Descripción",
      "DESCRIPTION_PLACEHOLDER": "Describe el tratamiento y sus beneficios...",
      "CATEGORIES": "Categorías",
      "CATEGORIES_PLACEHOLDER": "Seleccionar categorías...",
      "MORE_CATEGORIES": "más +",
      "PRICE_AND_DURATION": "Precio y duración",
      "PRICE": "Precio (€)",
      "PRICE_PLACEHOLDER": "ej. 120",
      "DURATION": "Duración (min)",
      "DURATION_PLACEHOLDER": "ej. 45",
      "PREP_TIME": "Tiempo de preparación (min)",
      "PREP_PLACEHOLDER": "0",
      "COOLDOWN_TIME": "Tiempo de cooldown (min)",
      "COOLDOWN_PLACEHOLDER": "0",
      "BUFFER_TIMES_TITLE": "Tiempos buffer dinámicos",
      "BUFFER_TIMES_DESC": "Define el tiempo extra que se bloqueará automáticamente en tu agenda para preparación y cuidados posteriores al tratamiento.",
      "ACTIVE_STATUS_LABEL": "Estado activo",
      "ACTIVE_STATUS_DESCRIPTION": "Cuando está activo, este servicio está disponible para reservar.",
      "STATUS": "Estado",
      "CANCEL": "Cancelar",
      "CREATE": "Crear servicio",
      "UPDATE": "Actualizar servicio",
      "ERROR_CREATING": "Error al crear el servicio",
      "ERROR_UPDATING": "Error al actualizar el servicio"
    },
    "CATEGORIES": {
      "TITLE": "Gestionar categorías de servicios",
      "SUBTITLE": "Crea y elimina categorías para clasificar los servicios.",
      "INPUT_PLACEHOLDER": "Introduce el nombre de la categoría...",
      "LOADING": "Cargando categorías...",
      "ALREADY_EXISTS": "Esta categoría ya existe",
      "ERROR_LOADING": "Error al cargar las categorías",
      "ERROR_CREATING": "Error al crear la categoría",
      "ERROR_DELETING": "Error al eliminar la categoría",
      "DELETE_CONFIRM_TITLE": "Confirmar eliminación",
      "DELETE_CONFIRM_MESSAGE": "¿Estás seguro de que deseas eliminar esta categoría?\n<strong>{{name}}</strong>"
    }
  },

  "COLLABORATORS": {
    "ADD": "Añadir colaborador",
    "SEARCH_PLACEHOLDER": "Buscar colaboradores por nombre o servicio...",
    "FILTER_BY": "Filtrar por:",
    "FILTER_BY_SERVICES": "Filtrar por servicios asignados",
    "ALL": "Todos",
    "AVAILABLE": "Disponible",
    "NOT_AVAILABLE": "No disponible",
    "SHOWING": "Mostrando",
    "OF": "de",
    "COLLABORATORS_COUNT": "colaboradores",
    "NO_COLLABORATORS": "No se encontraron colaboradores",
    "NO_COLLABORATORS_DESC": "Prueba a ajustar los filtros o la búsqueda.",
    "DELETE_CONFIRM_TITLE": "Confirmar eliminación",
    "DELETE_CONFIRM": "¿Estás seguro de que deseas eliminar este colaborador?\n<strong>{{name}}</strong>",
    "ERROR_LOADING": "Error al cargar colaboradores",
    "ERROR_DELETING": "Error al eliminar colaborador",
    "ERROR_SAVE": "Error al guardar colaborador",
    "MODAL": {
      "ADD_TITLE": "Añadir nuevo colaborador",
      "EDIT_TITLE": "Editar colaborador",
      "ADD_SUBTITLE": "Crea un nuevo colaborador y configura su horario y servicios.",
      "EDIT_SUBTITLE": "Actualiza datos, horario y servicios asignados.",
      "PROFILE": "Perfil del colaborador",
      "PROFILE_DESC": "Configura datos, horario de trabajo y servicios asignados.",
      "FIRST_NAME": "Nombre",
      "FIRST_NAME_PLACEHOLDER": "ej. Elena",
      "LAST_NAME": "Apellido",
      "LAST_NAME_PLACEHOLDER": "ej. Rossi",
      "EMAIL": "Correo electrónico",
      "EMAIL_PLACEHOLDER": "elena.rossi@empresa.com",
      "PHONE": "Teléfono",
      "PHONE_PLACEHOLDER": "+34 612 123 456",
      "ADDRESS": "Dirección",
      "ADDRESS_DESC": "Ubicación donde opera el colaborador para servicios presenciales.",
      "REMOTE": "Remoto",
      "REMOTE_DESCRIPTION": "Si está activo, los servicios se ofrecen en remoto (p. ej. videollamada); la dirección no aplica.",
      "ADDRESS_STREET": "Calle",
      "ADDRESS_STREET_PLACEHOLDER": "ej. Calle Mayor 10",
      "ADDRESS_CITY": "Ciudad",
      "ADDRESS_CITY_PLACEHOLDER": "ej. Madrid",
      "ADDRESS_PROVINCE": "Provincia",
      "ADDRESS_PROVINCE_PLACEHOLDER": "ej. M",
      "ADDRESS_POSTAL_CODE": "Código postal",
      "ADDRESS_POSTAL_CODE_PLACEHOLDER": "ej. 28001",
      "ADDRESS_COUNTRY": "País",
      "ADDRESS_COUNTRY_PLACEHOLDER": "ej. España",
      "ASSIGNED_SERVICES": "Servicios asignados",
      "ASSIGNED_SERVICES_PLACEHOLDER": "Selecciona los servicios a asignar...",
      "STATUS": "Estado de disponibilidad",
      "STATUS_DESCRIPTION": "Cuando está disponible, este colaborador puede asignarse a reservas.",
      "SAVE": "Guardar colaborador",
      "UPDATE": "Actualizar colaborador"
    },
    "WEEKDAYS": {
      "MONDAY": "Lunes",
      "TUESDAY": "Martes",
      "WEDNESDAY": "Miércoles",
      "THURSDAY": "Jueves",
      "FRIDAY": "Viernes",
      "SATURDAY": "Sábado",
      "SUNDAY": "Domingo"
    },
    "WORKING_HOURS": {
      "LABEL": "Horario de trabajo",
      "DESC": "Define cuándo está disponible este colaborador para reservas.",
      "EDIT": "Editar horario",
      "ADD": "Añadir horario",
      "TITLE": "Configurar horario de trabajo",
      "SUBTITLE": "Define el horario semanal y las pausas.",
      "QUICK_APPLY": "Aplicar rápido:",
      "EVERY_DAY": "Cada día",
      "WEEKDAYS": "Entre semana (lun–vie)",
      "WEEKENDS": "Fin de semana (sáb–dom)",
      "ADD_RANGE": "Añadir franja",
      "CLOSED": "Cerrado",
      "SAVE_HOURS": "Guardar horario",
      "INVALID_RANGE": "Franja no válida para {{day}}: la hora de inicio debe ser anterior al final.",
      "OVERLAP": "Franjas solapadas para {{day}}.",
      "DISCARD_CONFIRM": "¿Descartar cambios?",
      "SUMMARY_MON_FRI": "Lun–Vie",
      "SUMMARY_EVERY_DAY": "Cada día",
      "SUMMARY_DAYS": "{{count}} días / semana"
    }
  },

  "KNOWLEDGE_BASE": {
    "TITLE": "Base de conocimiento",
    "TAB_FAQS": "FAQ",
    "TAB_LINKS": "Enlaces externos",
    "DELETE_FAQ_CONFIRM_TITLE": "Confirmar eliminación",
    "DELETE_FAQ_CONFIRM_MESSAGE": "¿Seguro que quieres eliminar esta FAQ?\n<strong>{{question}}</strong>",
    "DELETE_LINK_CONFIRM_TITLE": "Confirmar eliminación",
    "DELETE_LINK_CONFIRM_MESSAGE": "¿Seguro que quieres eliminar este enlace?\n<strong>{{title}}</strong>",
    "SEARCH_FAQS": "Buscar FAQ...",
    "SEARCH_LINKS": "Buscar enlaces...",
    "ADD_FAQ": "Añadir FAQ",
    "ADD_LINK": "Añadir enlace",
    "EMPTY_FAQS_TITLE": "No se encontraron FAQ",
    "EMPTY_FAQS_DESC": "Ninguna pregunta coincide con la búsqueda. Prueba a añadir una nueva o ajustar los términos.",
    "EMPTY_LINKS_TITLE": "No se encontraron enlaces",
    "EMPTY_LINKS_DESC": "Empieza a construir tu base de conocimiento añadiendo enlaces a recursos externos.",
    "MODAL": {
      "TITLE_ADD_FAQ": "Añadir nueva FAQ",
      "TITLE_EDIT_FAQ": "Editar FAQ",
      "TITLE_ADD_LINK": "Añadir nuevo enlace",
      "TITLE_EDIT_LINK": "Editar enlace",
      "FAQ_SUBTITLE": "Enseña a la IA una respuesta concreta de tu negocio.",
      "LINK_SUBTITLE": "Proporciona un recurso externo que la IA pueda consultar.",
      "FAQ_DETAILS": "Detalles de la FAQ",
      "LINK_INFO": "Información del enlace",
      "QUESTION": "Pregunta",
      "QUESTION_PLACEHOLDER": "ej. ¿Cuál es el horario de apertura?",
      "ANSWER": "Respuesta",
      "ANSWER_PLACEHOLDER": "Escribe la respuesta detallada para la IA...",
      "TITLE": "Título",
      "TITLE_PLACEHOLDER": "ej. Catálogo 2024",
      "URL": "URL",
      "URL_PLACEHOLDER": "https://ejemplo.com",
      "SHORT_DESCRIPTION": "Descripción breve",
      "SHORT_DESCRIPTION_PLACEHOLDER": "Explica a la IA qué contiene este enlace...",
      "CANCEL": "Cancelar",
      "SAVE_CHANGES": "Guardar cambios",
      "ADD_FAQ": "Añadir FAQ",
      "ADD_LINK": "Añadir enlace",
      "ERROR_SAVE": "No se pudo guardar. Inténtalo de nuevo."
    },
    "ERROR_LOADING_FAQ": "Error al cargar las FAQ",
    "ERROR_LOADING_LINKS": "Error al cargar los enlaces",
    "ERROR_DELETE_FAQ": "Error al eliminar la FAQ",
    "ERROR_DELETE_LINK": "Error al eliminar el enlace"
  },

  "ERRORS": {
    "AUTH_INVALID_CREDENTIALS": "Email o contraseña inválidos",
    "AUTH_TOKEN_EXPIRED": "Tu sesión ha expirado, por favor inicia sesión nuevamente",
    "AUTH_UNAUTHORIZED": "No estás autorizado para acceder a este recurso",
    "AUTH_EMAIL_ALREADY_EXISTS": "Ya existe una cuenta con este email",
    "AUTH_FORBIDDEN": "No tienes permiso para realizar esta acción",

    "TENANT_NOT_FOUND": "Tenant no encontrado",
    "TENANT_ALREADY_EXISTS": "Ya existe un tenant con este nombre",
    "TENANT_NAME_TAKEN": "Este nombre ya está en uso",
    "TENANT_CREATION_FAILED": "Error al crear el tenant",
    "TENANT_UPDATE_FORBIDDEN": "Solo los super administradores pueden modificar tenants",
    "TENANT_DELETE_FORBIDDEN": "Solo los super administradores pueden eliminar tenants",
    "TENANT_ACCESS_DENIED": "Acceso denegado a este tenant",
    "TENANT_INVITE_FORBIDDEN": "Solo los super administradores o los administradores del tenant pueden invitar usuarios",

    "USER_NOT_FOUND": "Usuario no encontrado",
    "USER_EMAIL_INVALID": "Dirección de email inválida",
    "USER_ROLE_INVALID": "Rol de usuario inválido",
    "USER_UPDATE_FORBIDDEN": "No puedes modificar este usuario",
    "USER_ASSIGN_FORBIDDEN": "Solo los super administradores pueden asignar usuarios a tenants",
    "USER_REMOVE_FORBIDDEN": "Solo los super administradores pueden eliminar usuarios de tenants",

    "INVITE_NOT_FOUND": "Invitación no encontrada",
    "INVITE_EXPIRED": "Esta invitación ha expirado",
    "INVITE_ALREADY_USED": "Esta invitación ya ha sido utilizada",
    "INVITE_CREATION_FAILED": "Error al crear la invitación",
    "INVITE_EMAIL_SEND_FAILED": "No se pudo enviar el correo de invitación. La invitación se revirtió. Verifica la clave API de Resend, los IDs de plantilla y la configuración del remitente.",

    "CONTACT_NOT_FOUND": "Contacto no encontrado",
    "CONTACT_ACCESS_DENIED": "Acceso denegado a este contacto",
    "CONTACT_CREATION_FORBIDDEN": "Solo admin o super_admin pueden crear contactos",
    "CONTACT_UPDATE_FORBIDDEN": "Solo admin o super_admin pueden actualizar contactos",
    "CONTACT_DELETE_FORBIDDEN": "Solo admin o super_admin pueden eliminar contactos",
    "CONTACT_DUPLICATE_EMAIL": "Ya existe un contacto con este email en tu tenant",

    "VALIDATION_REQUIRED_FIELD": "Este campo es obligatorio",
    "VALIDATION_INVALID_EMAIL": "Formato de email inválido",
    "VALIDATION_MIN_LENGTH": "El valor es demasiado corto",
    "VALIDATION_MAX_LENGTH": "El valor es demasiado largo",

    "SYSTEM_INTERNAL_ERROR": "Ha ocurrido un error inesperado",
    "SYS_001": "Error desconocido",
    "SYSTEM_DATABASE_ERROR": "Operación de base de datos fallida",
    "NETWORK_ERROR": "Error de conexión al servidor"
  },

  "ERROR_MODAL": {
    "TITLE": "Error",
    "HEADING": "Algo ha ido mal",
    "STATUS": "Estado",
    "ERROR_CODE": "Código de error",
    "MESSAGE": "Mensaje",
    "PATH": "Ruta",
    "TIMESTAMP": "Fecha y hora",
    "DETAILS": "Detalles",
    "TECHNICAL_DETAILS": "Detalles técnicos",
    "NO_MESSAGE": "Sin mensaje",
    "CLOSE": "Cerrar"
  },

  "SUCCESS": {
    "TENANT_CREATED": "Tenant creado exitosamente",
    "TENANT_UPDATED": "Tenant actualizado exitosamente",
    "TENANT_DELETED": "Tenant eliminado exitosamente",
    "USER_INVITED": "Invitación enviada exitosamente",
    "USER_UPDATED": "Usuario actualizado exitosamente",
    "USER_ASSIGNED": "Usuario asignado al tenant exitosamente",
    "USER_REMOVED": "Usuario removido del tenant exitosamente",
    "INVITE_ACCEPTED": "Invitación aceptada exitosamente"
  },

  "INVITE_ACCEPT": {
    "TITLE": "Aceptar invitación",
    "SUBTITLE_LOADING": "Completando el registro...",
    "SUBTITLE_VALID": "Completa tu perfil para unirte al tenant",
    "SUBTITLE_INVALID": "Ingresa el enlace de invitación recibido por email",
    "VALIDATING": "Validando invitación...",
    "INVITED_BY": "Has sido invitado por",
    "THIS_TENANT": "este tenant",
    "EMAIL": "Email",
    "ROLE": "Rol",
    "FIRST_NAME": "Nombre",
    "LAST_NAME": "Apellido",
    "PASSWORD": "Contraseña",
    "CONFIRM_PASSWORD": "Confirmar contraseña",
    "PHONE_OPTIONAL": "Teléfono (opcional)",
    "PASSWORD_MISMATCH": "Las contraseñas no coinciden.",
    "ACCEPTING": "Aceptando...",
    "ACCEPT_BUTTON": "Aceptar invitación",
    "SUCCESS_REDIRECT": "¡Invitación aceptada! Redirigiendo al panel...",
    "BACK_TO_LOGIN": "Volver al inicio de sesión",
    "INVALID_TOKEN": "Token de invitación no válido",
    "INVITE_INVALID_OR_EXPIRED": "Invitación no válida o expirada",
    "VALIDATION_ERROR": "Error al validar la invitación",
    "ACCEPT_ERROR": "Error al aceptar la invitación",
    "ACCOUNT_CREATE_ERROR": "Error al crear la cuenta",
    "LOAD_USER_ERROR": "Cuenta creada pero no pudimos cargar tu perfil. Intenta iniciar sesión."
  },

  "FIREBASE_AUTH": {
    "EMAIL_ALREADY_IN_USE": "Este correo ya está en uso",
    "WEAK_PASSWORD": "La contraseña debe tener al menos 6 caracteres",
    "INVALID_EMAIL": "Dirección de email no válida",
    "TOO_MANY_ATTEMPTS": "Demasiados intentos. Intenta más tarde",
    "OPERATION_NOT_ALLOWED": "Este método de acceso no está habilitado",
    "USER_DISABLED": "Esta cuenta ha sido deshabilitada",
    "GENERIC": "Error de autenticación. Intenta de nuevo",
    "INVALID_CREDENTIAL": "Email o contraseña incorrectos",
    "NETWORK_ERROR": "Error de red. Comprueba tu conexión e inténtalo de nuevo",
    "POPUP_CLOSED": "Inicio de sesión cancelado",
    "ACCOUNT_EXISTS_DIFFERENT_CREDENTIAL": "Ya existe una cuenta con este email con otro método de acceso",
    "REQUIRES_RECENT_LOGIN": "Cierra sesión e inicia de nuevo para continuar",
    "EXPIRED_ACTION_CODE": "Este enlace ha expirado",
    "INVALID_ACTION_CODE": "Este enlace no es válido o ya se ha utilizado",
    "EMAIL_CHANGE_NEEDS_VERIFICATION": "Verifica tu nueva dirección de email",
    "UNKNOWN_ERROR": "Error desconocido. Inténtalo de nuevo"
  },
  "AGENDA": {
    "WEEKDAYS_SHORT": {
      "SUNDAY": "Dom",
      "MONDAY": "Lun",
      "TUESDAY": "Mar",
      "WEDNESDAY": "Mié",
      "THURSDAY": "Jue",
      "FRIDAY": "Vie",
      "SATURDAY": "Sáb"
    },
    "WEEKDAY_LETTERS": "L,M,X,J,V,S,D",
    "MONTHS": {
      "JANUARY": "Enero",
      "FEBRUARY": "Febrero",
      "MARCH": "Marzo",
      "APRIL": "Abril",
      "MAY": "Mayo",
      "JUNE": "Junio",
      "JULY": "Julio",
      "AUGUST": "Agosto",
      "SEPTEMBER": "Septiembre",
      "OCTOBER": "Octubre",
      "NOVEMBER": "Noviembre",
      "DECEMBER": "Diciembre"
    },
    "NO_AVAILABLE_SLOTS": "Sin horarios",
    "SLOT_BOOKED": "Ya reservado",
    "NEW_APPOINTMENT": "Nueva cita",
    "SEARCH_PLACEHOLDER": "Buscar por título, cliente o notas...",
    "FILTER_BY": "Filtrar por:",
    "ALL": "Todos",
    "CONFIRMED": "Confirmados",
    "PENDING": "Pendientes",
    "COMPLETED": "Completados",
    "CANCELLED": "Cancelados",
    "CANCELLED_BY_CLIENT": "Cancelados por el cliente",
    "LIST": "Lista",
    "CALENDAR": "Calendario",
    "TODAY": "Hoy",
    "VIEW_DAY": "Día",
    "VIEW_WEEK": "Semana",
    "VIEW_MONTH": "Mes",
    "ADVANCED_FILTERS": "Filtros avanzados",
    "DATE_FROM": "Fecha desde",
    "DATE_TO": "Fecha hasta",
    "SERVICE": "Servicio",
    "CLIENT": "Cliente",
    "ALL_SERVICES": "Todos los servicios",
    "ALL_CLIENTS": "Todos los clientes",
    "RESET_FILTERS": "Restablecer filtros",
    "APPLY_FILTERS": "Aplicar filtros",
    "NO_APPOINTMENTS": "No se encontraron citas con este filtro.",
    "EDIT": "Editar",
    "COMPLETE": "Completar",
    "NO_SHOW": "No presentado",
    "CANCELLED_BY_CLIENT_LABEL": "Cancelada por el cliente",
    "NO_SHOW_LABEL": "No asistió (no-show)",
    "NO_SHOW_CONFIRM_TITLE": "Marcar como no-show",
    "NO_SHOW_CONFIRM_MESSAGE": "¿Marcar esta cita como no-show? El cliente no asistió.",
    "NO_SHOW_CONFIRM_YES": "Marcar no-show",
    "CANCEL": "Cancelar",
    "CONFIRM": "Confirmar",
    "ERROR_LOADING": "Error al cargar las citas",
    "DELETE_CONFIRM_TITLE": "Eliminar cita",
    "DELETE_CONFIRM_MESSAGE": "¿Seguro que quieres eliminar esta cita? Esta acción no se puede deshacer.",
    "DELETE_CONFIRM_YES": "Eliminar",
    "ERROR_UPDATE": "Error al actualizar la cita",
    "ERROR_SAVE": "Error al guardar",
    "CANCEL_CONFIRM_TITLE": "Cancelar cita",
    "CANCEL_CONFIRM_MESSAGE": "¿Seguro que quieres cancelar esta cita?",
    "CANCEL_CONFIRM_YES": "Sí, cancelar",
    "MODAL": {
      "ADD_TITLE": "Nueva cita",
      "EDIT_TITLE": "Editar cita",
      "ADD_SUBTITLE": "Programar una nueva cita",
      "EDIT_SUBTITLE": "Actualizar detalles de la cita",
      "SERVICE": "Servicio",
      "SELECT_SERVICE": "Seleccionar servicio",
      "SEARCH_SERVICE": "Buscar servicio...",
      "NO_SERVICES": "No se encontraron servicios",
      "TITLE": "Título",
      "TITLE_PLACEHOLDER": "ej. Corte y estilo",
      "CLIENT": "Cliente",
      "SELECT_CLIENT": "Seleccionar cliente",
      "SEARCH_CLIENT": "Buscar cliente...",
      "NO_CLIENTS": "No se encontraron clientes",
      "COLLABORATOR": "Colaborador (opcional)",
      "SELECT_COLLABORATOR": "Seleccionar colaborador",
      "SEARCH_COLLABORATOR": "Buscar colaborador...",
      "NO_COLLABORATORS": "No se encontraron colaboradores",
      "STATUS": "Estado",
      "DATE": "Fecha",
      "START_TIME": "Hora inicio",
      "END_TIME": "Hora fin",
      "NOTES": "Notas (opcional)",
      "NOTES_PLACEHOLDER": "Añadir notas internas...",
      "SAVE": "Guardar cambios",
      "CREATE": "Crear cita"
    },
    "STATUS": {
      "CONFIRMED": "Confirmado",
      "PENDING": "Pendiente",
      "COMPLETED": "Completado",
      "CANCELLED": "Cancelado",
      "CANCELLED_BY_CLIENT": "Cancelado por el cliente",
      "NO_SHOW": "No-show"
    },
    "COMPLETED_LABEL": "Completado",
    "FORMS": {
      "BOOKING_FORM": "Formulario de reserva",
      "RESPONSES_TITLE": "Respuestas del formulario",
      "RESPONSES_SUBTITLE": "Ver las respuestas enviadas para esta cita",
      "LINK_TITLE": "Enlace público al formulario",
      "COPY_LINK": "Copiar enlace",
      "NO_SUBMISSION": "Aún no se ha generado ningún formulario para esta cita.",
      "STATUS_PENDING": "Formulario no completado",
      "STATUS_SUBMITTED": "Formulario completado",
      "ANSWERS_TITLE": "Respuestas enviadas",
      "PRIVACY_TITLE": "Privacy & Policy",
      "PRIVACY_ACCEPTED_AT": "Aceptada el",
      "NO_ANSWER": "Sin respuesta",
      "VIEW_RESPONSES": "Ver respuestas",
      "NO_FORM_FOR_APPOINTMENT": "No hay formulario de reserva asociado a esta cita.",
      "ERROR_LOADING_FORM": "Error al cargar el formulario",
      "ERROR_LOADING_SUBMISSION": "Error al cargar las respuestas",
      "ERROR_NO_APPOINTMENT": "Selecciona una cita con formulario de reserva para ver las respuestas."
    }
  },

  "FORMS": {
    "PUBLIC": {
      "NOT_FOUND": "No se encontró el formulario o el enlace no es válido.",
      "ALREADY_SUBMITTED": "Ya has enviado este formulario. ¡Gracias!",
      "ANSWER_PLACEHOLDER": "Escribe tu respuesta...",
      "SUBMIT": "Enviar formulario",
      "NEXT": "Siguiente",
      "BACK": "Volver",
      "STEP_1_LABEL": "Datos y solicitudes",
      "STEP_2_LABEL": "Elegir horario",
      "PRIVACY_STEP_LABEL": "Privacy & Policy",
      "PRIVACY_ACCEPT_LABEL": "He leído y acepto la Privacy & Policy",
      "SUBMITTED_ANSWERS": "Respuestas enviadas",
      "SUMMARY_TITLE": "Resumen de tu solicitud",
      "YOUR_ANSWERS": "Tus respuestas",
      "YOUR_BOOKING": "Tu reserva",
      "CANCEL_BOOKING": "Cancelar reserva",
      "BOOKING_CANCELLED_SUCCESS": "Reserva cancelada correctamente",
      "BOOKING_CANCELLED_ERROR": "No se pudo cancelar la reserva",
      "BOOKING_DATE": "Fecha",
      "BOOKING_TIME": "Hora",
      "BOOKING_SERVICE": "Servicio",
      "BOOKING_WITH": "Con",
      "BOOKING_DURATION": "Duración",
      "BOOKING_CONTEXT_TITLE": "Detalles de la reserva",
      "BOOKING_CONTEXT_REGION": "Resumen del servicio y del profesional",
      "BOOKING_CONFIRM_TITLE": "Confirmar reserva",
      "CALENDAR_LOADING": "Cargando horarios...",
      "BOOKING_SUCCESS_TITLE": "Reserva confirmada.",
      "BOOKING_SUCCESS_MESSAGE": "Puedes cerrar esta página. Se ha enviado un mensaje de resumen al chat.",
      "PREFILLED_SLOT_NOTICE": "Horario fijado por el operador: {{date}} {{startTime}}–{{endTime}}",
      "BOOK_CTA": "Reservar",
      "CONFIRM_CTA": "Confirmar",
      "CONFIRMING": "Confirmando...",
      "BOOKING_NOTE_LABEL": "Notas (opcional)",
      "BOOKING_NOTE_PLACEHOLDER": "Añade notas para la cita",
      "DURATION_FMT_MINUTES": "{{m}} minutos",
      "DURATION_FMT_ONE_HOUR": "1 hora",
      "DURATION_FMT_HOURS": "{{h}} horas",
      "DURATION_FMT_ONE_HOUR_AND_MINUTES": "1 hora y {{m}} minutos",
      "DURATION_FMT_HOURS_AND_MINUTES": "{{h}} horas y {{m}} minutos",
      "ERROR_LOADING": "Error al cargar el formulario",
      "ERROR_SUBMITTING": "Error al enviar el formulario",
      "REQUIRED_FIELD": "Este campo es obligatorio",
      "INVALID_TOKEN": "Este enlace al formulario no es válido o ha caducado.",
      "SUBMIT_SUCCESS": "¡Gracias! Tu formulario se envió correctamente.",
      "ERROR_LOADING_SLOTS": "No se pudieron cargar los horarios disponibles.",
      "ERROR_BOOKING": "No se pudo completar la reserva. Inténtalo de nuevo."
    }
  },

  "WIDGET_DEMO": {
    "TITLE": "Demo de Widget de Chat",
    "DESCRIPTION": "Esta es una página de ejemplo para probar el widget de chat. El widget aparece en la esquina inferior derecha.",
    "DEMO_PAGE_TITLE": "Página Demo",
    "DEMO_PAGE_DESCRIPTION": "Esta página simula un sitio web con el widget integrado. Puedes interactuar con el chatbot haciendo clic en el icono en la esquina inferior derecha.",
    "ERROR_NO_CODE": "No hay código de widget disponible. Genera un código de widget desde Configuración.",
    "ERROR_NOT_GENERATED": "Código de widget no generado. Genera un código de widget desde Configuración.",
    "ERROR_LOADING": "Error al cargar el widget. Verifica que el archivo del widget esté disponible.",
    "SUCCESS_LOADED": "¡Widget cargado con éxito!",
    "SUCCESS_MESSAGE": "Haz clic en el icono en la esquina inferior derecha para abrir el chat y probar el widget.",
    "LOADING": "Cargando widget...",
    "HOW_TO_TEST": "Cómo probar:",
    "STEP_1": "Haz clic en el icono del widget en la esquina inferior derecha",
    "STEP_2": "Se abrirá la ventana de chat",
    "STEP_3": "Escribe un mensaje para probar la conversación",
    "STEP_4": "Verifica que las respuestas del chatbot funcionen correctamente",
    "NOTE": "Nota: Esta es una página demo. Para integrar el widget en tu sitio, copia el snippet HTML desde Configuración → Integraciones.",
    "GO_TO_SETTINGS": "Ir a Configuración"
  },

  "WIDGET": {
    "CHAT_TITLE": "Chat",
    "INPUT_PLACEHOLDER": "Escribe tu mensaje...",
    "SEND_BUTTON": "Enviar",
    "CLOSE_BUTTON": "Cerrar chat",
    "OPEN_CHAT": "Abrir chat",
    "TYPING": "Escribiendo...",
    "ERROR_SENDING": "Lo siento, encontré un error. Por favor, inténtalo de nuevo.",
    "ERROR_VALIDATION": "Código de widget inválido o tenant no activo"
  },

  "WIDGET_TEST": {
    "TITLE": "Prueba de Integración del Widget",
    "DESCRIPTION": "Introduce un código de widget para probar la integración del chatbot en tu sitio.",
    "CONFIGURATION_TITLE": "Configuración del Widget",
    "CONFIGURATION_DESCRIPTION": "Introduce el código del widget para validarlo y cargar el widget de prueba",
    "WIDGET_CODE_LABEL": "Código del Widget",
    "WIDGET_CODE_PLACEHOLDER": "Introduce el código del widget (ej. ABC123XYZ)",
    "WIDGET_CODE_REQUIRED": "El código del widget es obligatorio",
    "LOADING": "Cargando...",
    "LOAD_WIDGET": "Cargar Widget",
    "ERROR_PREFIX": "Error:",
    "VALID_WIDGET": "Widget válido!",
    "TENANT": "Tenant",
    "SNIPPET_TITLE": "Snippet HTML",
    "SNIPPET_DESCRIPTION": "Copia este snippet y pégalo en tu sitio web para integrar el widget",
    "COPY_SNIPPET": "Copiar Snippet",
    "HOW_TO_TITLE": "Cómo usar el widget",
    "HOW_TO_STEP_1": "Genera u obtén tu código de widget desde la sección de Configuración",
    "HOW_TO_STEP_2": "Pega el snippet HTML en la sección <code>&lt;head&gt;</code> o antes del cierre <code>&lt;/body&gt;</code> de tu sitio",
    "HOW_TO_STEP_3": "El widget aparecerá automáticamente como un ícono en la esquina inferior derecha",
    "HOW_TO_STEP_4": "Los usuarios podrán hacer clic en el ícono para abrir el chat",
    "NOTE_PREFIX": "Nota:",
    "NOTE_TEXT": "El widget se carga dinámicamente en esta página para pruebas. Asegúrate de que la URL del JS del widget sea accesible públicamente cuando lo integres en tu sitio.",
    "ERROR_SUSPENDED": "Este widget ha sido suspendido.",
    "ERROR_BLOCKED": "Este widget ha sido bloqueado.",
    "ERROR_INVALID": "Código de widget no válido o desconocido.",
    "ERROR_LOAD": "No se pudo cargar el widget. Verifica el código e inténtalo de nuevo.",
    "ERROR_SCRIPT": "No se pudo cargar el script del widget. Verifica que el archivo esté disponible."
  },

  "CONVERSATIONS": {
    "SEARCH_PLACEHOLDER": "Buscar mensajes, clientes o etiquetas...",
    "FILTER_BY": "Filtrar por:",
    "FILTERS": {
      "ALL": "Todos",
      "UNREAD": "No leídos",
      "PENDING": "Pendientes",
      "RESOLVED": "Resueltos"
    },
    "CLIENT_PROFILE": {
      "TITLE": "Perfil del Cliente",
      "SEE_CONTACT": "Ver contacto",
      "FULL_NAME": "Nombre Completo",
      "EMAIL_ADDRESS": "Dirección de Email",
      "PHONE_NUMBER": "Número de Teléfono",
      "TAGS": "Etiquetas",
      "SELECT_CONVERSATION": "Selecciona una conversación para ver los detalles del cliente."
    },
    "AI_SUMMARY": {
      "TITLE": "Resumen AI de la Conversación",
      "NO_SUMMARY": "No hay resumen disponible para esta conversación aún."
    },
    "CHAT": {
      "SELECT_CONVERSATION": "Selecciona una conversación de la lista para empezar a chatear.",
      "LAST_VISIT": "Última visita",
      "AI_MODE": "Modo AI",
      "AI_MODE_ACTIVE_NOTICE": "El Modo AI está activo. El chatbot responderá automáticamente a los mensajes entrantes.",
      "REPLY_PLACEHOLDER": "Escribe tu respuesta… (Enter para enviar, Shift+Enter para nueva línea)",
      "SENDING": "Enviando..."
    },
    "CHANNELS": {
      "TELEGRAM": "Telegram",
      "WHATSAPP": "WhatsApp",
      "WEBCHAT": "Chat Web"
    },
    "ERROR_LOAD_LIST": "No se pudieron cargar las conversaciones.",
    "ERROR_LOAD_DETAILS": "No se pudo cargar esta conversación.",
    "ERROR_SEND_MESSAGE": "No se pudo enviar el mensaje.",
    "ERROR_AI_MODE": "No se pudo actualizar el modo IA."
  },
  "FLOWS": {
    "ADD_FLOW": "Agregar Flow",
    "NO_FLOWS": "Aún no hay flows configurados.",
    "UNNAMED": "Flow sin nombre",
    "SHOWING": "Mostrando",
    "FLOWS_LABEL": "flows",
    "ERROR_LOADING": "No se pudieron cargar los flows.",
    "ERROR_CREATE": "No se pudo crear el flow.",
    "ERROR_UPDATE": "No se pudo actualizar el flow.",
    "ERROR_DELETE": "No se pudo eliminar el flow.",
    "ERROR_STATUS": "No se pudo actualizar el estado del flow.",
    "ERROR_TEST": "No se pudo enviar la prueba.",
    "ERROR_LOADING_EXECUTIONS": "No se pudieron cargar las ejecuciones del flow.",
    "CREATED": "Flow creado con éxito.",
    "UPDATED": "Flow actualizado con éxito.",
    "DELETED": "Flow eliminado con éxito.",
    "DELETE_CONFIRM_TITLE": "Eliminar flow",
    "DELETE_CONFIRM": "¿Eliminar este flow?\n<strong>{{name}}</strong>",
    "STATUS_UPDATED": "Estado del flow actualizado.",
    "TEST_SENT": "Mensajes de prueba enviados con éxito.",
    "COLUMNS": {
      "NAME": "Nombre",
      "TRIGGER": "Evento",
      "TIMING": "Tiempo",
      "STATUS": "Estado"
    },
    "TRIGGERS": {
      "APPOINTMENT_REQUESTED": "Cita solicitada",
      "APPOINTMENT_CONFIRMED": "Cita confirmada",
      "APPOINTMENT_UPDATED": "Cita actualizada",
      "APPOINTMENT_CANCELLED": "Cita cancelada",
      "APPOINTMENT_CANCELLED_BY_CLIENT": "Cita cancelada por el cliente",
      "APPOINTMENT_COMPLETED": "Cita completada",
      "APPOINTMENT_NO_SHOW": "Cita no-show",
      "APPOINTMENT_REMINDER": "Recordatorio de cita (franja)",
      "CONVERSATION_NO_RESPONSE": "Sin respuesta tras mensaje saliente",
      "FORM_NOT_COMPLETED": "Formulario incompleto"
    },
    "TIMING": {
      "BEFORE": "Antes",
      "AFTER": "Después"
    },
    "UNITS": {
      "MINUTES": "minutos",
      "HOURS": "horas",
      "DAYS": "días"
    },
    "STATUS": {
      "ACTIVE": "Activo",
      "PAUSED": "Pausado",
      "AUTO_DISABLED": "Desactivado"
    },
    "EXECUTION_STATUS": {
      "PENDING": "Pendiente",
      "PROCESSING": "En proceso",
      "SENT": "Completado",
      "FAILED": "Error",
      "CANCELLED": "Cancelado"
    },
    "TABS": {
      "DEFINITIONS": "Flows",
      "EXECUTIONS": "Ejecuciones"
    },
    "EXECUTIONS": {
      "NO_EXECUTIONS": "No se encontraron ejecuciones.",
      "FILTER_ALL": "Todos",
      "OPEN_DETAILS": "Abrir detalles",
      "DETAILS_TITLE": "Detalles de ejecución del flow",
      "COLUMNS": {
        "FLOW": "Flow",
        "SCHEDULED_AT": "Programado para",
        "RUN_AT": "Ejecutado el",
        "RETRIES": "Reintentos",
        "TARGET": "Destino",
        "ERROR": "Error"
      }
    },
    "CHANNEL": {
      "AUTO": "Preferido del cliente"
    },
    "MODAL": {
      "ADD_TITLE": "Crear Flow",
      "EDIT_TITLE": "Editar Flow",
      "SUBTITLE": "Configura un mensaje automático para tus clientes.",
      "GENERAL": "General",
      "TITLE": "Título",
      "TITLE_PLACEHOLDER": "ej. Recordatorio de cita después de 24h",
      "DESCRIPTION": "Descripción",
      "DESCRIPTION_PLACEHOLDER": "Notas internas (opcional)",
      "TRIGGER": "Evento disparador",
      "TRIGGER_PLACEHOLDER": "Selecciona uno o más disparadores...",
      "TIMING": "Tiempo",
      "BEFORE_AFTER": "Antes / Después",
      "NUMBER": "Número",
      "TIME_UNIT": "Unidad",
      "MESSAGE": "Mensaje",
      "MESSAGE_TEMPLATE": "Mensaje de referencia",
      "MESSAGE_PLACEHOLDER": "Hola {name}, tu cita es el {date} a las {start_time}.",
      "PLACEHOLDER_SELECT_LABEL": "Insertar marcador",
      "ADD_PLACEHOLDER": "Agregar",
      "PLACEHOLDERS_HINT": "Marcadores: {name}, {last_name}, {full_name}, {date}, {start_time}, {end_time}, {treatment}, {phone}, {mail}, {form_link}, {form_name}, {conversation_link}, {conversation_id}",
      "CHANNEL": "Canal de envío",
      "CHANNEL_OVERRIDE": "Canal",
      "CREATE": "Crear",
      "SAVE": "Guardar"
    },
    "TEST": {
      "TITLE": "Enviar Prueba",
      "SUBTITLE": "Envía un mensaje de prueba inmediato a los miembros del equipo seleccionados.",
      "SELECT_RECIPIENTS": "Seleccionar destinatarios...",
      "SEND": "Enviar Prueba"
    }
  },
  "FLOOR_PLAN": {
    "ROOMS": "Salas",
    "ROOM_DRAG_HANDLE_ARIA": "Arrastrar para reordenar la sala",
    "ERROR_REORDER_ROOMS": "No se pudo guardar el orden de las salas.",
    "ROOM_BLOCK": "Bloquear sala",
    "ROOM_BLOCK_CONFIRM_TITLE": "¿Bloquear esta sala?",
    "ROOM_BLOCK_CONFIRM_MESSAGE": "La sala «{{name}}» no aceptará reservas ni traslados mientras esté bloqueada. Mesas y combinaciones seguirán visibles pero deshabilitadas.",
    "ROOM_UNBLOCK": "Desbloquear sala",
    "ROOM_UNBLOCK_CONFIRM_TITLE": "¿Reactivar esta sala?",
    "ROOM_UNBLOCK_CONFIRM_MESSAGE": "La sala «{{name}}» volverá a estar disponible para reservas y traslados.",
    "ROOM_BLOCKED_BADGE": "Bloqueada",
    "ROOM_BLOCKED_HINT": "Sala bloqueada: no hay reservas ni traslados a esta sala. Mesas y combinaciones siguen visibles pero deshabilitadas.",
    "ROOM_BLOCKED_TOAST": "Sala bloqueada.",
    "ROOM_UNBLOCKED_TOAST": "Sala desbloqueada.",
    "ERROR_TOGGLE_ROOM_BLOCK": "No se pudo actualizar el estado de la sala.",
    "ROOM_NAME": "Nombre de sala",
    "ROOM_DESCRIPTION": "Descripcion",
    "ROOM_COLOR": "Color de sala",
    "ADD_ROOM_TITLE": "Crear sala",
    "EDIT_ROOM_TITLE": "Editar sala",
    "SAVE_ROOM": "Guardar sala",
    "ADD_SECTION": "Agregar",
    "ADD_PANEL_TITLE": "Agregar en la sala",
    "ADD_PANEL_TABLE": "Mesa",
    "ADD_PANEL_COMPONENT": "Componente",
    "ADD_TABLE_BLOCK": "Agregar mesa",
    "ADD_NEW_TABLE": "Agregar nueva mesa",
    "EDIT_TABLE_TITLE": "Editar mesa",
    "SAVE_TABLE": "Guardar mesa",
    "ADD_COMPONENT_BLOCK": "Agregar componente",
    "ADD_COMPONENT": "Agregar componente",
    "ADD_NEW_COMPONENT": "Agregar nuevo componente",
    "EDIT_COMPONENT_TITLE": "Editar componente",
    "SAVE_COMPONENT": "Guardar componente",
    "COMPONENT_NAME": "Nombre",
    "COMPONENT_NAME_PLACEHOLDER": "ej. Entrada principal, Puerta cocina",
    "COMPONENT_TYPE": "Tipo",
    "COMPONENT_COLOR": "Color",
    "CREATE_COMPONENT": "Crear",
    "COMPONENT_CREATED": "Componente creado correctamente.",
    "COMPONENT_UPDATED": "Componente actualizado correctamente.",
    "COMPONENT_DELETED": "Componente eliminado correctamente.",
    "COMPONENT_TYPE_DOOR": "Puerta",
    "COMPONENT_TYPE_WINDOW": "Ventana",
    "COMPONENT_TYPE_BATHROOM": "Bano",
    "COMPONENT_TYPE_KITCHEN": "Cocina",
    "COMPONENT_TYPE_BAR": "Bar",
    "COMPONENT_TYPE_STAIRS": "Escaleras",
    "COMPONENT_TYPE_PILLAR": "Columna",
    "COMPONENT_TYPE_GENERIC": "Generico",
    "ADD_ROOM": "Agregar sala",
    "NO_ROOMS": "No hay salas",
    "TABLES": "mesas",
    "SEATS": "cubiertos",
    "EDIT_LAYOUT": "Editar layout",
    "VIEW_MODE": "Modo vista",
    "SEARCH_TABLE": "Buscar mesa",
    "FILTER_ALL": "Todos los estados",
    "RESET_VIEW": "Restablecer vista",
    "ZOOM_IN": "Acercar",
    "ZOOM_OUT": "Alejar",
    "ZOOM_LEVEL": "Zoom: {{pct}}% (tambien puedes usar la rueda del raton sobre el lienzo)",
    "TABLE_NAME": "Nombre mesa",
    "LAYOUT_TOOLS": "Herramientas de layout",
    "TABLE_NAME_LABEL": "Nombre de la mesa",
    "TABLE_NAME_PLACEHOLDER": "ej. Mesa 12",
    "TABLE_NUMBER": "Numero de mesa",
    "TABLE_NUMBER_PLACEHOLDER": "ej. 1, A1, VIP-1",
    "TABLE_DISPLAY_NAME": "Nombre mostrado",
    "TABLE_DISPLAY_NAME_PLACEHOLDER": "Como se ve en grande en el plano",
    "TABLE_CODE_AUTO_HINT": "Se asigna automáticamente un código único (ej. T-001) al crear la mesa. No se puede cambiar.",
    "TABLE_CODE_LABEL": "Código",
    "TABLE_COLOR": "Color de la mesa",
    "TABLE_SEATS_LABEL": "Cubiertos (numero)",
    "MIN_SEATS": "Cubiertos minimos",
    "MIN_SEATS_INVALID": "Los cubiertos minimos no pueden superar los cubiertos.",
    "TABLE_SHAPE_LABEL": "Forma de la mesa",
    "ADD_TABLE": "Agregar mesa",
    "DECORATIONS_TITLE": "Decoraciones (proximamente)",
    "DECORATIONS_HINT": "Plantas, muros y columnas estaran disponibles en esta seccion.",
    "SHAPE_ROUND": "Redonda",
    "SHAPE_SQUARE": "Cuadrada",
    "SHAPE_RECTANGLE": "Rectangular",
    "SHAPE_RECTANGLE_SHORT": "Rect",
    "NO_TABLES": "No hay mesas en esta sala",
    "NO_TABLES_MATCH_SEARCH": "Ninguna mesa coincide con tu búsqueda.",
    "CREATE_COMBINATION": "Crear combinacion",
    "STATUS_FREE": "Libre",
    "STATUS_RESERVED": "Reservada",
    "STATUS_OCCUPIED": "Ocupada",
    "STATUS_BLOCKED": "Bloqueada",
    "ROOM_CREATED": "Sala creada correctamente.",
    "ROOM_DELETED": "Sala eliminada correctamente.",
    "TABLE_CREATED": "Mesa creada correctamente.",
    "TABLE_UPDATED": "Mesa actualizada correctamente.",
    "TABLE_DELETED": "Mesa eliminada correctamente.",
    "DELETE_TABLE_CONFIRM_TITLE": "Eliminar mesa",
    "DELETE_TABLE_CONFIRM_MESSAGE": "Estas seguro de que quieres eliminar la mesa {{name}}?",
    "COMBINATION_CREATED": "Combinacion creada correctamente.",
    "COMBINATION_DELETED": "Combinacion eliminada correctamente.",
    "ERROR_LOAD_ROOMS": "No se pudieron cargar las salas.",
    "ERROR_CREATE_ROOM": "No se pudo crear la sala.",
    "ERROR_UPDATE_ROOM": "No se pudo actualizar la sala.",
    "ERROR_DELETE_ROOM": "No se pudo eliminar la sala.",
    "ERROR_LOAD_TABLES": "No se pudieron cargar las mesas.",
    "ERROR_LOAD_COMBINATIONS": "No se pudieron cargar las combinaciones de mesas.",
    "ERROR_LOAD_ROOM_LAYOUT": "No se pudo cargar el layout de la sala (mesas, combinaciones o componentes).",
    "ERROR_CREATE_COMPONENT": "No se pudo crear el componente de layout.",
    "ERROR_UPDATE_COMPONENT": "No se pudo actualizar el componente de layout.",
    "ERROR_DELETE_COMPONENT": "No se pudo eliminar el componente de layout.",
    "ERROR_CREATE_TABLE": "No se pudo crear la mesa.",
    "ERROR_UPDATE_TABLE": "No se pudo actualizar la mesa.",
    "ERROR_DELETE_TABLE": "No se pudo eliminar la mesa.",
    "ERROR_CREATE_COMBINATION": "No se pudo crear la combinacion.",
    "COMBINATIONS_TITLE": "Combinaciones de mesas",
    "COMBINATIONS_EMPTY": "No hay combinaciones en esta sala. En modo edicion usa Ctrl+clic (⌘ en Mac) en las mesas para seleccionarlas y luego anade una combinacion.",
    "COMBINATION_NEW_TITLE": "Nueva combinacion",
    "COMBINATION_EDIT_TITLE": "Editar combinacion",
    "COMBINATION_NAME": "Nombre de la combinacion",
    "COMBINATION_NAME_PLACEHOLDER": "ej. Banquete A, Grupo grande",
    "COMBINATION_DISPLAY_NAME": "Nombre mostrado",
    "COMBINATION_DISPLAY_NAME_PLACEHOLDER": "Como aparece en listas y al resaltar en el plano",
    "COMBINATION_CODE_AUTO_HINT": "Se asigna automáticamente un código único (ej. C-001) al crear la combinación. No se puede cambiar.",
    "COMBINATION_CODE_LABEL": "Código",
    "COMBINATION_COLOR": "Color de la combinación",
    "COMBINATION_MIN_PARTY": "Comensales mínimos",
    "COMBINATION_MAX_PARTY": "Comensales máximos",
    "COMBINATION_PARTY_HINT": "Comensales reservables en esta combinación — no ligados a la suma de cubiertos de las mesas. Valores: 1–99 para mín. y máx.",
    "COMBINATION_BOOKABLE_RANGE": "Reservas {{min}}–{{max}} comensales",
    "COMBINATION_PARTY_MIN_MAX_INVALID": "El mínimo de comensales no puede ser mayor que el máximo.",
    "COMBINATION_PARTY_BOUNDS_INVALID": "El mínimo y el máximo deben estar entre 1 y 99.",
    "COMBINATION_PARTY_CAPACITY_INVALID": "El rango debe estar entre 1 y {{cap}} (cubiertos totales de las mesas seleccionadas).",
    "ERROR_COMBINATION_PARTY_MIN": "El mínimo debe estar entre 1 y 99.",
    "ERROR_COMBINATION_PARTY_MAX": "El máximo debe estar entre 1 y 99.",
    "ERROR_COMBINATION_PARTY_CAPACITY": "El rango de comensales no puede superar los cubiertos totales de la combinación.",
    "ERROR_COMBINATION_PARTY_MAX_BOUND": "El mínimo y el máximo no pueden superar 99.",
    "ERROR_COMBINATION_MIN_SEATS": "La combinación debe tener al menos 2 cubiertos totales.",
    "COMBINATION_TABLES_PICK": "Mesas en la sala",
    "COMBINATION_TOTAL_SEATS_PREVIEW": "Cubiertos totales (vista previa)",
    "COMBINATION_USE_CANVAS_SELECTION": "Usar seleccion actual del lienzo",
    "COMBINATION_USE_CANVAS_SELECTION_EDIT_MODE": "Activa “Editar diseño” para seleccionar varias mesas en el plano (Ctrl+clic, ⌘ en Mac) y luego usa este botón.",
    "COMBINATION_NEED_TWO_TABLES": "Selecciona al menos dos mesas.",
    "COMBINATION_NON_COMBINABLE_NOTE": "No combinable — habilitelo en la ficha de la mesa.",
    "COMBINATION_SAVE": "Guardar combinacion",
    "COMBINATION_UPDATED": "Combinacion actualizada correctamente.",
    "TABLE_COMBINABLE": "Mesa combinable",
    "TABLE_COMBINABLE_HINT": "Solo las mesas combinables pueden agruparse en una combinacion con nombre para reservas.",
    "DELETE_COMBINATION_CONFIRM_TITLE": "Eliminar combinacion",
    "DELETE_COMBINATION_CONFIRM_MESSAGE": "Eliminar la combinacion {{name}}? Las mesas permanecen en la sala.",
    "MULTI_SELECT_HINT": "En modo edicion: Ctrl+clic (⌘ en Mac) en una mesa para anadirla o quitarla de la seleccion. Util al crear combinaciones.",
    "MULTI_SELECT_HINT_SHORT": "Ctrl+clic (⌘) en mesa: multiseleccion",
    "COMBINATION_BADGE_TOOLTIP": "En {{count}} combinacion(es)",
    "COMBINATION_HIGHLIGHT_ON_PLAN": "Resaltar estas mesas en el plano (vuelve a pulsar para quitar)",
    "ERROR_COMBINATION_DUPLICATE_NAME": "Ya existe una combinacion con este nombre en esta sala.",
    "ERROR_COMBINATION_MIN_TABLES": "La combinacion debe incluir al menos dos mesas distintas.",
    "ERROR_COMBINATION_INVALID_TABLES": "Algunas mesas no son validas o pertenecen a otra sala.",
    "ERROR_COMBINATION_NOT_COMBINABLE": "Una o mas mesas no son combinables.",
    "ERROR_COMBINATION_BOOKINGS": "Operacion bloqueada: hay reservas futuras vinculadas a esta sala o a estas mesas.",
    "RESIZE_TABLE": "Redimensionar mesa",
    "RESIZE_COMPONENT": "Redimensionar componente",
    "SNAP_GRID_ON": "Rejilla magnetica: activa",
    "SNAP_GRID_OFF": "Rejilla magnetica: desactiva",
    "NO_CLIP_ON": "No clip: activo — mesas y componentes pueden superponerse (siguen los limites del canvas). Desactiva al terminar el rediseno.",
    "NO_CLIP_OFF": "No clip: inactivo — espacio solo entre mesas; los componentes de layout pueden superponerse entre si y con las mesas.",
    "ADVANCED": "Avanzado",
    "ADVANCED_ARIA": "Opciones de layout avanzadas",
    "ADVANCED_SNAP": "Rejilla magnetica",
    "ADVANCED_NO_CLIP": "No clip",
    "CANVAS_SHRINK_WIDTH": "Reducir ancho del canvas",
    "CANVAS_GROW_WIDTH": "Aumentar ancho del canvas",
    "CANVAS_SHRINK_HEIGHT": "Reducir alto del canvas",
    "CANVAS_GROW_HEIGHT": "Aumentar alto del canvas",
    "CANVAS_WIDTH": "Ancho canvas",
    "CANVAS_HEIGHT": "Alto canvas",
    "LIVE_TITLE": "Sala (en vivo)",
    "LIVE_SUBTITLE": "Sala en vivo — toca una mesa para reservar, marcar llegada o bloquear. Los colores siguen las reservas y la hora actual.",
    "LIVE_TAB_FLOOR": "Plano de sala",
    "LIVE_TAB_LIST": "Lista de reservas",
    "LIVE_TAB_ELENCO": "Por mesa",
    "LIVE_VIEW_TABS_ARIA": "Elegir vista: plano o lista",
    "LIVE_ACTIONS_ARIA": "Acciones de reserva: reserva automática y búsqueda de reservas",
    "LIVE_LIST_HEADING": "Reservas",
    "LIVE_LIST_HINT": "Toca una fila para abrir la mesa y gestionar la reserva. Cambia la fecha en la barra lateral.",
    "LIVE_LIST_EMPTY_ROOM": "No hay reservas para esta sala en la fecha seleccionada.",
    "LIVE_LIST_TIMELINE_LEGEND": "Franja del día ({{start}}–{{end}})",
    "LIVE_LIST_ROW_ARIA": "{{start}} a {{end}}, {{title}}, {{place}}{{codePart}}. Abrir mesa.",
    "LIVE_LIST_PLACEMENT_TABLE": "Mesa {{name}}",
    "LIVE_LIST_PLACEMENT_COMBO": "Combinación {{name}}",
    "LIVE_LIST_TABLE_CAPTION": "Mesa",
    "LIVE_LIST_TABLE_COMBO_DETAIL": "{{combo}} — {{tables}}",
    "LIVE_LIST_TABLE_UNSPECIFIED": "Sin asignar",
    "LIVE_LIST_PLACEMENT_UNSPEC": "Ubicación no indicada",
    "LIVE_LIST_OPEN_ERROR": "No se pudo abrir una mesa para esta reserva.",
    "LIVE_BOOKING_CODE": "Código de reserva",
    "LIVE_SEARCH_LABEL": "Buscar",
    "LIVE_SEARCH_PLACEHOLDER": "Mesa, combinación, código de reserva, título o cliente…",
    "LIVE_SEARCH_CLEAR": "Borrar búsqueda",
    "LIVE_LIST_SEARCH_EMPTY": "Ninguna reserva coincide. Prueba otra mesa, cliente o código de reserva.",
    "LIVE_FLOOR_SEARCH_EMPTY": "Ninguna mesa de esta sala coincide con la búsqueda. Borra el filtro o prueba otro nombre o código de reserva.",
    "LIVE_DATE": "Fecha",
    "LIVE_REFRESH": "Actualizar",
    "LIVE_ROOM_LAYOUT_LOADING": "Cargando plano de la sala…",
    "LIVE_TABLE_SHEET_TITLE": "Mesa {{name}}",
    "LIVE_ADD_RESERVATION": "Añadir reserva",
    "LIVE_ADD_WALKIN": "Añadir walk-in / ocupado",
    "LIVE_RESERVE_TABLE": "Reservar",
    "LIVE_AUTO_RES_OPEN": "Reserva automática",
    "LIVE_AUTO_RES_TITLE": "Reserva automática",
    "LIVE_AUTO_RES_HINT": "Introduce datos y busca la mejor mesa disponible en las salas seleccionadas.",
    "LIVE_AUTO_RES_DATE": "Fecha de la reserva",
    "LIVE_AUTO_RES_DATE_INVALID": "Elige una fecha de reserva válida.",
    "LIVE_AUTO_RES_ROOMS": "Salas donde buscar",
    "LIVE_AUTO_RES_ROOMS_PLACEHOLDER": "Seleccionar salas",
    "LIVE_AUTO_RES_ROOMS_REQUIRED": "Selecciona al menos una sala.",
    "LIVE_AUTO_RES_FIND": "Buscar mesa",
    "LIVE_AUTO_RES_FOUND": "Mesa sugerida",
    "LIVE_AUTO_RES_FOUND_TABLE": "Mesa: {{table}}",
    "LIVE_AUTO_RES_FOUND_ROOM": "Sala: {{room}}",
    "LIVE_AUTO_RES_FOUND_TIME": "Horario: {{start}}-{{end}}",
    "LIVE_AUTO_RES_CONFIRM": "Confirmar reserva",
    "LIVE_AUTO_RES_FIND_ANOTHER": "Buscar otra mesa",
    "LIVE_AUTO_RES_NO_TABLE": "No hay mesa disponible con estos filtros.",
    "LIVE_AUTO_RES_NO_MORE_TABLES": "No hay más mesas alternativas.",
    "LIVE_AUTO_RES_LOOKUP_ERROR": "No se pudieron buscar mesas disponibles.",
    "LIVE_AUTO_RES_SUMMARY_TITLE": "Reserva confirmada",
    "LIVE_AUTO_RES_SUMMARY_TABLE": "Mesa: {{table}}",
    "LIVE_AUTO_RES_SUMMARY_ROOM": "Sala: {{room}}",
    "LIVE_AUTO_RES_SUMMARY_TIME": "Horario: {{start}}-{{end}}",
    "LIVE_AUTO_RES_SUMMARY_GUEST": "Cliente: {{guest}}",
    "LIVE_GLOBAL_RES_OPEN": "Buscar reserva",
    "LIVE_GLOBAL_RES_TITLE": "Búsqueda de reservas",
    "LIVE_GLOBAL_RES_HINT": "Busca por código de reserva, nombre del cliente o nombre de mesa/combinación. Incluye todas las fechas y estados (cerradas y en mesa).",
    "LIVE_GLOBAL_RES_FIELD_LABEL": "Texto de búsqueda",
    "LIVE_GLOBAL_RES_PLACEHOLDER": "Código, cliente, mesa…",
    "LIVE_GLOBAL_RES_SEARCH": "Buscar",
    "LIVE_GLOBAL_RES_OPEN_HINT": "Toca para abrir la mesa en la fecha de la reserva.",
    "LIVE_GLOBAL_RES_EMPTY": "No se encontraron reservas.",
    "LIVE_GLOBAL_RES_INITIAL": "Introduce al menos 2 caracteres y pulsa Buscar.",
    "LIVE_GLOBAL_RES_QUERY_SHORT": "Introduce al menos 2 caracteres.",
    "LIVE_GLOBAL_RES_ERROR": "La búsqueda falló. Inténtalo de nuevo.",
    "LIVE_GLOBAL_RES_OPEN_NO_TABLE": "No se puede abrir: no hay mesa vinculada a esta reserva.",
    "LIVE_BLOCK_TABLE": "Bloquear mesa",
    "LIVE_UNBLOCK_TABLE": "Desbloquear mesa",
    "LIVE_RELEASE_DAY": "Anular todas las reservas (día)",
    "LIVE_MARK_SEATED": "Cliente llegó",
    "LIVE_MARK_SEATED_SUCCESS": "Marcado como en mesa.",
    "LIVE_MARK_SEATED_ERROR": "No se pudo actualizar la llegada.",
    "LIVE_RELEASE_TABLE_EARLY": "Liberar mesa — los clientes se fueron antes del fin de la reserva",
    "LIVE_RELEASE_TABLE_EARLY_TITLE": "Liberar mesa",
    "LIVE_RELEASE_TABLE_EARLY_SUB": "Clientes fuera · termina la franja ahora",
    "LIVE_RELEASE_EARLY_SUCCESS": "Mesa liberada. Reserva cerrada con la hora de fin indicada.",
    "LIVE_RELEASE_EARLY_ERROR": "No se pudo liberar la mesa.",
    "LIVE_RELEASE_CHOICE_TITLE": "Mesa en uso",
    "LIVE_RELEASE_CHOICE_BODY": "¿Los clientes se fueron? Cierra la reserva con la hora actual como fin. Si marcaste la llegada por error, anula solo la llegada: la reserva sigue confirmada como antes.",
    "LIVE_RELEASE_CHOICE_UNDO": "Anular llegada (no en mesa)",
    "LIVE_RELEASE_CHOICE_CLOSE": "Clientes se fueron — cerrar reserva",
    "LIVE_UNDO_ARRIVAL_SUCCESS": "Llegada anulada. La reserva vuelve a estar solo reservada.",
    "LIVE_UNDO_ARRIVAL_ERROR": "No se pudo anular la llegada.",
    "LIVE_GUEST_SEATED_BADGE": "En mesa",
    "LIVE_VISUAL_BLOCKED": "Bloqueada",
    "LIVE_VISUAL_FREE": "Disponible (ahora)",
    "LIVE_VISUAL_WAITING": "Reservada — en espera",
    "LIVE_VISUAL_SEATED": "Comensales en mesa",
    "LIVE_VISUAL_DAY_BOOKED": "Tiene reservas (este día)",
    "LIVE_CANCEL_RESERVATION": "Cancelar esta reserva",
    "LIVE_CANCEL_RESERVATION_SUCCESS": "Reserva cancelada.",
    "LIVE_CANCEL_RESERVATION_ERROR": "No se pudo cancelar la reserva.",
    "LIVE_RESERVATIONS": "Reservas",
    "LIVE_RES_COVERS": "{{count}} comensales",
    "LIVE_RES_FINISHED": "Finalizada",
    "LIVE_RES_FINISHED_NOTE": "Cerrada · franja {{start}}–{{end}}",
    "LIVE_RESERVATIONS_BADGE": "res.",
    "LIVE_NO_RESERVATIONS": "No hay reservas para este día.",
    "LIVE_COMBINATIONS": "Combinaciones",
    "LIVE_COMBOS_SHORT": "combo",
    "LIVE_TABLE_SEATS_TOOLTIP": "{{count}} cubiertos",
    "LIVE_TABLE_RES_TOOLTIP": "{{count}} reservas para hoy",
    "LIVE_STATUS_ACTIONS": "Estado de la mesa",
    "LIVE_STATUS_LABEL": "Estado",
    "LIVE_CYCLE_STATUS": "Siguiente estado",
    "LIVE_FREE_CONFIRM_TITLE": "¿Cancelar reservas?",
    "LIVE_FREE_CONFIRM_BODY": "La mesa {{name}} tiene reservas para este día. ¿Pasarla a Libre y cancelar esas reservas? Esto no se puede deshacer desde aquí.",
    "LIVE_FREE_CONFIRM_SUBMIT": "Cancelar reservas y poner Libre",
    "LIVE_FREE_CONFIRM_BACK": "Mantener el estado actual",
    "LIVE_FREE_SUCCESS": "Reservas canceladas y mesa en Libre.",
    "LIVE_FREE_ERROR": "No se pudo liberar la mesa.",
    "LIVE_NOTES": "Notas del equipo",
    "LIVE_ERROR_LOAD": "No se pudo cargar la vista en vivo.",
    "LIVE_OPEN_EDITOR": "Abrir editor del plano",
    "MANUAL_RES_TITLE": "Reserva de mesa — {{status}}",
    "MANUAL_RES_TITLE_RESERVE": "Nueva reserva de mesa",
    "MANUAL_RES_HINT": "Crea una reserva con horario para el cliente. Los colores en vivo dependen de las reservas y de la hora actual.",
    "MANUAL_RES_START": "Horario",
    "MANUAL_RES_END": "Hora de fin (opcional)",
    "MANUAL_RES_END_HINT": "Déjalo vacío para usar la duración por defecto de la configuración del chatbot/sala.",
    "MANUAL_RES_DURATION_HINT": "La hora de fin se calcula automáticamente según la duración configurada.",
    "MANUAL_RES_SLOTS_LOADING": "Cargando horarios disponibles…",
    "MANUAL_RES_SLOTS_EMPTY": "No hay horarios reservables para este día, comensales o mesa. Revisa los ajustes del restaurante o la disponibilidad.",
    "MANUAL_RES_SLOTS_LOAD_ERROR": "No se pudieron cargar los horarios reservables.",
    "MANUAL_RES_PARTY": "Comensales",
    "MANUAL_RES_NOTES": "Notas (opcional)",
    "MANUAL_RES_GUEST_CONTACT": "Cliente / contacto",
    "MANUAL_RES_GUEST_PLACEHOLDER": "Elige un contacto o sin datos",
    "MANUAL_RES_SEARCH_CONTACTS": "Buscar contactos…",
    "MANUAL_RES_CREATE_CONTACT": "+ Nuevo contacto",
    "MANUAL_RES_NO_CONTACT": "Sin nombre / walk-in",
    "MANUAL_RES_FILL_GUEST": "Selecciona un contacto o walk-in.",
    "MANUAL_RES_WALK_IN_DISPLAY": "Walk-in (sin contacto)",
    "MANUAL_RES_CONTACT_MODE": "Cliente",
    "MANUAL_RES_EXISTING": "Contacto existente",
    "MANUAL_RES_NEW": "Nuevo contacto",
    "MANUAL_RES_SELECT_CONTACT": "Seleccionar contacto",
    "MANUAL_RES_FIRST": "Nombre",
    "MANUAL_RES_LAST": "Apellido",
    "MANUAL_RES_PHONE": "Teléfono",
    "MANUAL_RES_EMAIL": "Email (opcional)",
    "MANUAL_RES_SUBMIT": "Guardar reserva",
    "MANUAL_RES_CANCEL": "Cancelar",
    "MANUAL_RES_FILL_CONTACT": "Selecciona un contacto.",
    "MANUAL_RES_FILL_NEW": "Nombre, apellido y teléfono son obligatorios.",
    "MANUAL_RES_START_REQUIRED": "Selecciona un horario.",
    "MANUAL_RES_SUCCESS": "Reserva guardada.",
    "MANUAL_RES_ERROR": "No se pudo guardar la reserva.",
    "MANUAL_RES_CONTACTS_LOAD_ERROR": "No se pudieron cargar los contactos.",
    "LIVE_EDIT_RESERVATION": "Editar reserva",
    "LIVE_EDIT_RESERVATION_TITLE": "Editar reserva",
    "LIVE_EDIT_RESERVATION_HINT": "Elige primero el día y luego la hora según la disponibilidad. También puedes cambiar comensales y notas. Con el cliente en mesa solo se pueden editar las notas.",
    "LIVE_EDIT_RES_DATE": "Fecha de la reserva",
    "LIVE_EDIT_RES_DATE_HINT": "Al cambiar el día, los horarios de inicio disponibles se actualizan automáticamente.",
    "LIVE_EDIT_START_INVALID_FOR_DATE": "Elige un horario de inicio entre los disponibles para el día seleccionado (o cambia fecha o comensales e inténtalo de nuevo).",
    "LIVE_EDIT_GUEST_SEATED_HINT": "El cliente está en mesa: solo puedes actualizar las notas. Para cambiar hora o mesa, libera la mesa primero.",
    "LIVE_EDIT_SUCCESS": "Reserva actualizada.",
    "LIVE_EDIT_ERROR": "No se pudo actualizar la reserva.",
    "LIVE_EDIT_NO_CHANGES": "No hay cambios que guardar.",
    "LIVE_MOVE_RESERVATION": "Mover a otra mesa o combo",
    "LIVE_MOVE_RESERVATION_TITLE": "Mover reserva",
    "LIVE_MOVE_RESERVATION_HINT": "Elige otra mesa en cualquier sala. Misma franja y duración (debe estar libre, incluidas reservas en combo).",
    "LIVE_MOVE_RESERVATION_HINT_COMBO": "Elige otra combinación o mesa individual en cualquier sala. Misma franja y duración; todas las mesas del destino deben estar libres.",
    "LIVE_MOVE_TARGET_DESTINATION": "Destino",
    "LIVE_MOVE_TARGET_REQUIRED": "Selecciona un destino.",
    "LIVE_MOVE_OPTION_COMBO_TITLE": "{{name}} — combo · {{seats}} cubiertos",
    "LIVE_MOVE_OPTION_COMBO_SUB": "{{room}} · {{slot}} · {{party}} cubiertos · Mesas: {{tables}}",
    "LIVE_MOVE_OPTION_TITLE": "{{name}} — máx. {{seats}} cubiertos",
    "LIVE_MOVE_OPTION_SUB": "{{room}} · Franja {{slot}} · {{party}} cubiertos (compatible)",
    "LIVE_MOVE_TARGETS_LOADING": "Buscando mesas y combinaciones disponibles para esta franja…",
    "LIVE_MOVE_TARGETS_ERROR": "No se pudieron cargar los destinos para el traslado.",
    "LIVE_MOVE_SEARCH_PLACEHOLDER": "Buscar por mesa, combo o sala…",
    "LIVE_MOVE_TARGET_TABLE": "Mesa de destino",
    "LIVE_MOVE_SUBMIT": "Mover",
    "LIVE_MOVE_SUCCESS": "Reserva movida.",
    "LIVE_MOVE_ERROR": "No se pudo mover la reserva.",
    "LIVE_MOVE_TABLE_REQUIRED": "Selecciona una mesa de destino.",
    "LIVE_MOVE_NO_TARGETS": "No hay otra mesa compatible en ninguna sala: cubiertos suficientes y franja libre para este horario.",
    "LIVE_MOVE_NO_TARGETS_COMBO": "No hay otra combinación o mesa compatible en ninguna sala: comensales permitidos y franja libre en todas las mesas implicadas.",
    "LIVE_MOVE_NO_TARGETS_ONLY_ONE_COMBO": "En el local solo existe la combinación actual «{{comboName}}» en sala «{{room}}» ({{totalSeats}} cubiertos físicos). Para mover {{party}} comensales, crea otra combinación (en cualquier sala) desde el editor del plano. Las mesas sueltas tienen como máximo {{maxTableSeats}} cubiertos cada una.",
    "LIVE_APPT_STATUS_CONFIRMED": "Confirmada",
    "LIVE_APPT_STATUS_PENDING": "Pendiente",
    "LIVE_APPT_STATUS_COMPLETED": "Completada",
    "LIVE_APPT_STATUS_CANCELLED": "Cancelada",
    "LIVE_APPT_STATUS_CANCELLED_BY_CLIENT": "Cancelada por el cliente",
    "LIVE_APPT_STATUS_NO_SHOW": "No presentado",
    "ANALYTICS_TITLE": "Analytics de sala",
    "ANALYTICS_SUBTITLE": "Reservas y uso de mesas en el periodo seleccionado (fechas UTC).",
    "ANALYTICS_FROM": "Desde",
    "ANALYTICS_TO": "Hasta",
    "ANALYTICS_PRESET_7D": "Últimos 7 días",
    "ANALYTICS_PRESET_30D": "Últimos 30 días",
    "ANALYTICS_APPLY": "Aplicar",
    "ANALYTICS_LOADING": "Cargando analytics…",
    "ANALYTICS_ERROR": "No se pudieron cargar las analytics. Revisa el rango de fechas e inténtalo de nuevo.",
    "ANALYTICS_KPI_TOTAL": "Reservas totales",
    "ANALYTICS_KPI_WITH_TABLE": "Con mesa asignada",
    "ANALYTICS_KPI_WITH_COMBO": "Con combinación de mesas",
    "ANALYTICS_KPI_CONFIRMED": "Confirmadas",
    "ANALYTICS_KPI_NO_SHOW": "No presentado",
    "ANALYTICS_KPI_CANCELLED": "Canceladas (todas)",
    "ANALYTICS_CHART_BOOKINGS": "Reservas por día",
    "ANALYTICS_CHART_STATUS": "Por estado",
    "ANALYTICS_CHART_HOUR": "Reservas por hora (inicio)",
    "ANALYTICS_CHART_TOP_TABLES": "Mesas más usadas",
    "ANALYTICS_CHART_DAY_STATUS": "Estado operativo de mesas por día",
    "ANALYTICS_TOP_TABLES": "Mesas más usadas",
    "ANALYTICS_TOP_ROOMS": "Salas más usadas",
    "ANALYTICS_RECENT": "Reservas recientes",
    "LIVE_RES_PARTIAL_BADGE": "Estancia parcial",
    "LIVE_RES_PLACEMENT_MISSING": "Ubicación no en plano",
    "ANALYTICS_UNFULFILLED_TITLE": "Chat: solicitudes de mesa no cubiertas",
    "ANALYTICS_UNFULFILLED_HINT": "Registradas cuando el chatbot no encuentra mesa tras la hora pedida y ±30 minutos.",
    "ANALYTICS_UNFULFILLED_EMPTY": "No hay solicitudes chat sin cubrir.",
    "ANALYTICS_UNFULFILLED_COL_WHEN": "Registrada",
    "ANALYTICS_UNFULFILLED_COL_PARTY": "Comensales",
    "ANALYTICS_UNFULFILLED_COL_OFFSETS": "Desplazamientos probados (min)",
    "ANALYTICS_NO_DATA": "Sin datos en este periodo.",
    "ANALYTICS_COL_TABLE": "Mesa",
    "ANALYTICS_COL_ROOM": "Sala",
    "ANALYTICS_COL_COUNT": "Recuento",
    "ANALYTICS_COL_DATE": "Fecha",
    "ANALYTICS_COL_TIME": "Hora",
    "ANALYTICS_COL_TITLE": "Título",
    "ANALYTICS_COL_STATUS": "Estado"
  }
}
